// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.6.1
//   protoc               unknown
// source: models/fabric_design.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import {
  AirflowType,
  airflowTypeFromJSON,
  airflowTypeToJSON,
  CablingStrategy,
  cablingStrategyFromJSON,
  cablingStrategyToJSON,
  ConnSourceType,
  connSourceTypeFromJSON,
  connSourceTypeToJSON,
  IpmProbeType,
  ipmProbeTypeFromJSON,
  ipmProbeTypeToJSON,
  PlacementStrategy,
  placementStrategyFromJSON,
  placementStrategyToJSON,
  ServerPortGroupType,
  serverPortGroupTypeFromJSON,
  serverPortGroupTypeToJSON,
  TopologyGroupType,
  topologyGroupTypeFromJSON,
  topologyGroupTypeToJSON,
} from "./fabric";
import { OsType, osTypeFromJSON, osTypeToJSON } from "./global";
import { FabricSoftwareConfig } from "./image";

export const protobufPackage = "models";

export enum MgmtCredentialBinding {
  MGMT_CREDENTIAL_BINDING_UNSPECIFIED = 0,
  MGMT_CREDENTIAL_BINDING_GROUP_DEFAULT = 1,
  MGMT_CREDENTIAL_BINDING_NODE_DEFAULT = 2,
  MGMT_CREDENTIAL_BINDING_NONE = 3,
  MGMT_CREDENTIAL_BINDING_EXPLICIT = 4,
  UNRECOGNIZED = -1,
}

export function mgmtCredentialBindingFromJSON(object: any): MgmtCredentialBinding {
  switch (object) {
    case 0:
    case "MGMT_CREDENTIAL_BINDING_UNSPECIFIED":
      return MgmtCredentialBinding.MGMT_CREDENTIAL_BINDING_UNSPECIFIED;
    case 1:
    case "MGMT_CREDENTIAL_BINDING_GROUP_DEFAULT":
      return MgmtCredentialBinding.MGMT_CREDENTIAL_BINDING_GROUP_DEFAULT;
    case 2:
    case "MGMT_CREDENTIAL_BINDING_NODE_DEFAULT":
      return MgmtCredentialBinding.MGMT_CREDENTIAL_BINDING_NODE_DEFAULT;
    case 3:
    case "MGMT_CREDENTIAL_BINDING_NONE":
      return MgmtCredentialBinding.MGMT_CREDENTIAL_BINDING_NONE;
    case 4:
    case "MGMT_CREDENTIAL_BINDING_EXPLICIT":
      return MgmtCredentialBinding.MGMT_CREDENTIAL_BINDING_EXPLICIT;
    case -1:
    case "UNRECOGNIZED":
    default:
      return MgmtCredentialBinding.UNRECOGNIZED;
  }
}

export function mgmtCredentialBindingToJSON(object: MgmtCredentialBinding): string {
  switch (object) {
    case MgmtCredentialBinding.MGMT_CREDENTIAL_BINDING_UNSPECIFIED:
      return "MGMT_CREDENTIAL_BINDING_UNSPECIFIED";
    case MgmtCredentialBinding.MGMT_CREDENTIAL_BINDING_GROUP_DEFAULT:
      return "MGMT_CREDENTIAL_BINDING_GROUP_DEFAULT";
    case MgmtCredentialBinding.MGMT_CREDENTIAL_BINDING_NODE_DEFAULT:
      return "MGMT_CREDENTIAL_BINDING_NODE_DEFAULT";
    case MgmtCredentialBinding.MGMT_CREDENTIAL_BINDING_NONE:
      return "MGMT_CREDENTIAL_BINDING_NONE";
    case MgmtCredentialBinding.MGMT_CREDENTIAL_BINDING_EXPLICIT:
      return "MGMT_CREDENTIAL_BINDING_EXPLICIT";
    case MgmtCredentialBinding.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export interface IpmSetting {
  /** Indicates whether ipm probe is disabled (unspecified), bidirectional or unidirectional */
  probeType: IpmProbeType;
  /** Ipm target id is the destination group id/name in the case of unidirectional probing. */
  ipmTargetId: string;
  /** uuid to reference the ipm configuration */
  ipmConfigId: string;
}

/**
 * The DesignObjectBaseData defines
 * the common base_data present in every
 * object of the blueprint
 */
export interface DesignObjectBaseData {
  /** The name of the blueprint object */
  name: string;
  /** The external id of the blueprint object (will be populated for node_id) */
  id: string;
  /** The short name of the blueprint object */
  shortName: string;
  /**
   * The relative position of the object in its
   * next level aggregation. For example
   * position of device in hw_set, position of
   * hw_set in switch/server group, position of
   * switch/server group in tier.
   */
  position: number;
  /** The fabric_id that this blueprint object is associated with */
  fabricId: string;
  nameAutoComputed: boolean;
}

export interface HwSet {
  baseData:
    | DesignObjectBaseData
    | undefined;
  /** The external id of the blueprint object (will be populated for node_id) */
  setId: string;
  /** The name of the blueprint object */
  name: string;
  /** The short name of the blueprint object */
  shortName: string;
  /**
   * The relative position of the object in its
   * next level aggregation. For example
   * position of device in hw_set, position of
   * hw_set in switch/server group, position of
   * switch/server group in tier.
   */
  position: number;
  /** The fabric_id that this blueprint object is associated with */
  fabricId: string;
  /** The tier that this blueprint object is associated with */
  tierId: string;
  /** The group that this blueprint object is associated with. */
  groupId: string;
  /** The model name/pid  of the devices in the hw set. */
  deviceModelName: string;
  psuModelName: string;
  airflowType: AirflowType;
  /**
   * The node ids corresponding to the devices in the hw set
   * This list will be sorted by the relative position of the
   * nodes within the hardware set. For templates, this will
   * have the name of the nodes, otherwise, this will be the
   * node uuids
   */
  nodes: DesignObjectBaseData[];
}

export interface Rail {
  baseData:
    | DesignObjectBaseData
    | undefined;
  /** The external id of the blueprint object (will be populated for node_id) */
  railId: string;
  /** The name of the blueprint object */
  name: string;
  /** The short name of the blueprint object */
  shortName: string;
  /**
   * The relative position of the object in its
   * next level aggregation. For example
   * position of device in hw_set, position of
   * hw_set in switch/server group, position of
   * switch/server group in tier.
   */
  position: number;
  /** The fabric_id that this blueprint object is associated with */
  fabricId: string;
}

export interface RailGroup {
  baseData:
    | DesignObjectBaseData
    | undefined;
  /** The external id of the blueprint object (will be populated for node_id) */
  groupId: string;
  /** The name of the blueprint object */
  name: string;
  /** The short name of the blueprint object */
  shortName: string;
  /**
   * The relative position of the object in its
   * next level aggregation. For example
   * position of device in hw_set, position of
   * hw_set in switch/server group, position of
   * switch/server group in tier.
   */
  position: number;
  /** The fabric_id that this blueprint object is associated with */
  fabricId: string;
  /**
   * number of rails in the group. This corresponds to the number of
   * GPUs on the platform.
   */
  count: number;
  /**
   * This specifies the id/name of the switch group that the rail is
   * associated with
   */
  switchGroupId: string;
  /** The strategy for placing rails on the switch */
  strategy: PlacementStrategy;
  /** The position of the group across all tiers. */
  overallGroupPosition: number;
  /**
   * number of reserved ports in a rail. This loosely corresponds to the number
   * of servers in the server group associated with the rail group
   * this rail is a member of. The user can pre-allocate ports for future use by
   * configuring a larger width than the number of currently associated servers.
   */
  railWidth: number;
  /** all the rails that are members of this rail group */
  rails: Rail[];
  /** When width_auto_computed is true, the rail width is auto computed from the defaults for the associated server group. */
  widthAutoComputed: boolean;
  /** When count_auto_computed is true, the rail count is auto computed from the defaults for the associated server group. */
  countAutoComputed: boolean;
}

export interface SwitchGroup {
  baseData:
    | DesignObjectBaseData
    | undefined;
  /** The external id of the blueprint object (will be populated for node_id) */
  groupId: string;
  /** The name of the blueprint object */
  name: string;
  /** The short name of the blueprint object */
  shortName: string;
  /**
   * The relative position of the object in its
   * next level aggregation. For example
   * position of device in hw_set, position of
   * hw_set in switch/server group, position of
   * switch/server group in tier.
   */
  position: number;
  /** The fabric that this blueprint object is associated with */
  fabricId: string;
  /** The tier that this blueprint object is associated with */
  tierId: string;
  /** The device model name. */
  baseModelName: string;
  /** The position of the group across all tiers. */
  overallGroupPosition: number;
  /**
   * The hw sets that belong to this switch group
   * This list will be sorted by the relative position of the
   * hardware sets within the switch group
   */
  hwSets: HwSet[];
  /**
   * The monitored boolean defines whether or not the switches in this switch group are externally managed.
   * In this case, they will only be monitored within Hyperfabric, and have software updated.
   * No config is pushed to these switches.
   */
  monitored: boolean;
  /** The OsType defines the operating system type of switches in the switch group. */
  osType: OsType;
  /** Enable ARS profile for all switches in the switch group. */
  enableArs: boolean;
  /** Enable auto port speed for all switches in the switch group. */
  enableAutoPort: boolean;
}

export interface ServerGroup {
  baseData:
    | DesignObjectBaseData
    | undefined;
  /** The external id of the blueprint object (will be populated for node_id) */
  groupId: string;
  /** The name of the blueprint object */
  name: string;
  /** The short name of the blueprint object */
  shortName: string;
  /**
   * The relative position of the object in its
   * next level aggregation. For example
   * position of device in hw_set, position of
   * hw_set in switch/server group, position of
   * switch/server group in tier.
   */
  position: number;
  /** The fabric that this blueprint object is associated with */
  fabricId: string;
  /** The tier that this blueprint object is associated with */
  tierId: string;
  /** The device model name. */
  baseModelName: string;
  /** The position of the group across all tiers. */
  overallGroupPosition: number;
  /**
   * The hw sets that belong to this switch group
   * This list will be sorted by the relative position of the
   * hardware sets within the server group
   */
  hwSets: HwSet[];
  /** The active_gpus bitmap describes which gpus are active. */
  activeGpus: number;
  /** A list of internal labels used for resource reservations and other internal purposes. */
  internalLabels: string[];
}

export interface Tier {
  baseData:
    | DesignObjectBaseData
    | undefined;
  /** The external id of the blueprint object (will be populated for node_id) */
  tierId: string;
  /** The name of the blueprint object */
  name: string;
  /** The short name of the blueprint object */
  shortName: string;
  /**
   * The relative position of the object in its
   * next level aggregation. For example
   * position of device in hw_set, position of
   * hw_set in switch/server group, position of
   * switch/server group in tier.
   */
  position: number;
  /** The fabric_id that this blueprint object is associated with */
  fabricId: string;
  allowedGroupTypes: TopologyGroupType[];
  /**
   * The server groups that are a part of the tier if one of
   * the allowed tier types is a server group
   */
  serverGroups: ServerGroup[];
  /**
   * The switch groups that are a part of the tier if one of
   * the allowed tier types is a switch group
   */
  switchGroups: SwitchGroup[];
}

export interface SwitchGroupConnectivityRule {
  /** The id of the rule */
  ruleId: string;
  /** The id and name of the first group in the connectivity rule */
  switchGroup1Id: string;
  /** The pluggable pid to be used for the ports of the devices in group 1 */
  switchGroup1PluggablePid: string;
  /** The pid to be used for the cable in the rule */
  cablePid: string;
  /** Breakout applied at the switches in sw group 1 in this rule */
  switchGroup1Breakout: boolean;
  /** The id and name of the second group in the connectivity rule */
  switchGroup2Id: string;
  /** The pluggable pid to be used for the ports of the devices in group 2 */
  switchGroup2PluggablePid: string;
  /** Breakout applied at the switches in sw group 2 in this rule */
  switchGroup2Breakout: boolean;
  /** number of direct connections between group 1 and group 2 */
  numDirectConnections: number;
  /** cabling strategy preferred for this rule */
  strategy: CablingStrategy;
  /** ipm configuration(s) for this rule */
  ipmProbes: IpmSetting[];
  /**
   * The IP MTU value to be applied to ports governed by this rule.
   * When zero, the default MTU for the port role is used.
   */
  mtu: number;
  /**
   * The FEC mode to be applied to ports governed by this rule.
   * When empty, FEC is auto-assigned from device model capabilities.
   */
  fec: string;
  /**
   * The notes associated with the connectivity rule.
   * This could describe
   */
  notes: string;
}

export interface ServerGroupConnectivityRule {
  /** The id of the rule */
  ruleId: string;
  /** The id and name of the server group in the connectivity rule */
  serverGroupId: string;
  /** The pluggable pid to be used for the ports of the devices in the server group */
  serverGroupPluggablePid: string;
  /** The pid to be used for the cable in the rule */
  cablePid: string;
  /** The id and name of the switch group in the connectivity rule */
  switchGroupId: string;
  /** The pluggable pid to be used for the ports of the devices in the switch group */
  switchGroupPluggablePid: string;
  /** Breakout mode at the switches in sw group  in this rule */
  switchGroupBreakout: boolean;
  /** The id and name of the rail group in the connectivity rule */
  railGroupId: string;
  /** number of direct connections between group 1 and group 2 */
  numDirectConnections: number;
  /** The port group type for the ports in question */
  portGroupType: ServerPortGroupType;
  /** cabling strategy preferred for this rule */
  strategy: CablingStrategy;
  /** Ipm settings for indirect connections */
  ipmProbes: IpmSetting[];
  /**
   * The notes associated with the connectivity rule.
   * This could describe
   */
  notes: string;
  /**
   * PortSetId refers to the position/index of the portGroup notably for east-west ports in the C880
   * for which there are multiple ports per slot. An id of zero means the there is only one portGroup of a given type
   * (no breakout); any non-zero value will refer a portGroup in a broken out list.
   */
  portSetId: number;
  /**
   * The IP MTU value to be applied to ports governed by this rule.
   * When zero, the default MTU for the port role is used.
   */
  mtu: number;
  /**
   * The FEC mode to be applied to ports governed by this rule.
   * When empty, FEC is auto-assigned from device model capabilities.
   */
  fec: string;
  /** The tray ids of the destination integrated switch. */
  torTrayIds: number[];
  /** The device model name of the destination server tray. */
  serverTrayModelName: string;
}

export interface NodePortConnectivityRule {
  /** The id of the rule */
  ruleId: string;
  /** The external node id and name of the first node in the connectivity rule */
  node1Id: string;
  /** The port name for the first node in the connectivity rule */
  node1PortName: string;
  /** The model name/pid for the pluggable to be used in the first node:port */
  node1PortPluggablePid: string;
  /** The pluggable pid to be used for the cable in the rule */
  cablePid: string;
  /** The id and name of the second node in the connectivity rule */
  node2Id: string;
  /** The port name for the second node in the connectivity rule */
  node2PortName: string;
  /** The model name/pid for the pluggable to be used in the second node:port */
  node2PortPluggablePid: string;
  /** The notes associated with the connectivity rule. */
  notes: string;
  /**
   * The IP MTU value to be applied to ports governed by this rule.
   * When zero, the default MTU for the port role is used.
   */
  mtu: number;
  /**
   * The FEC mode to be applied to ports governed by this rule.
   * When empty, FEC is auto-assigned from device model capabilities.
   */
  fec: string;
  /** The tray id/rack identifier of the first node in the connectivity rule. */
  node1TrayId: number;
  /** The tray id/rack identifier of the second node in the connectivity rule. */
  node2TrayId: number;
}

export interface NodePortOverrideRule {
  /** The id of the rule */
  ruleId: string;
  /** The id and name of the node in the override rule */
  nodeId: string;
  /** The port name for the node in the override rule */
  portName: string;
  /**
   * Pluggable associated with the node port. Can be a specific
   * breakout configuration.
   */
  pluggable: string;
  notes: string;
  /** The tray id/rack identifier of the node in the override rule. */
  trayId: number;
}

export interface CablingEndpoint {
  /** The name of the node in the connection */
  nodeName: string;
  /** The id of the node in the connection */
  nodeId: string;
  /** The name of the port in the connection */
  portName: string;
  /** The id of the port in the connection */
  portId: string;
  /** The name of the group in the connection */
  groupName: string;
  /** The id of the group in the connection */
  groupId: string;
  /** The tray_id/rack identifier */
  trayId: number;
  /** Parent node associated with the tray_id */
  parentId: string;
}

export interface CablingConnection {
  /** The node/port/group information for the first entity in the connection */
  local:
    | CablingEndpoint
    | undefined;
  /** The node/port/group information for the second entity in the connection */
  remote:
    | CablingEndpoint
    | undefined;
  /** The model name/pid for the pluggable to be used in the first node:port */
  pluggable: string;
  /** The model name/pid for the pluggable to be used in the second node:port */
  remotePluggable: string;
  /** The pid to be used for the cable in the connection */
  cablePid: string;
  /** The rail name associated with the remote entity in the connection */
  remoteRailName: string;
  /** The external rail id associated with the remote entity connection */
  remoteRailId: string;
  /** The rail group name associated with the remote entity in the connection */
  remoteRailGroupName: string;
  /** The external rail group name associated with the remote entity in the connection */
  remoteRailGroupId: string;
  /** connection source for the connection */
  connSourceType: ConnSourceType;
  /** The id of the connectivity rule that generated this connection */
  ruleId: string;
}

export interface FabricDesign {
  fabricId: string;
  tiers: Tier[];
  /** The rail groups associated with the design */
  railGroups: RailGroup[];
  switchGroupConnRules: SwitchGroupConnectivityRule[];
  serverGroupConnRules: ServerGroupConnectivityRule[];
  nodePortConnRules: NodePortConnectivityRule[];
  nodePortOverrideRules: NodePortOverrideRule[];
  /**
   * Deprecated: Use SetFabricDesignObjects in ProvisionFabrics for granular updates instead.
   *
   * @deprecated
   */
  isPartialSet: boolean;
  mgmtAuthConfigs: MgmtAuthConfig[];
}

/**
 * MgmtCredential represents reusable management auth material. Maps 1:1 with a
 * fabric.fabric_credential row. The same MgmtCredential may be used as a group-level
 * default (see MgmtAuthConfig.default_credential) or as a per-node override
 * (see MgmtNodeBinding.credential), and multiple bindings may share one row by
 * reference via credential_id.
 */
export interface MgmtCredential {
  /** Optional display name for the credential. Auto-generated if omitted. */
  name: string;
  /**
   * If set, references an existing fabric.fabric_credential row.
   * When credential_id is present together with username/password, the
   * existing credential is updated in place. When credential_id is present
   * alone the row is resolved without modification. On the read path,
   * credential_id and username are returned; password is never returned.
   */
  credentialId: string;
  username: string;
  password: string;
}

/**
 * MgmtNodeBinding configures management auth for one server within the
 * enclosing MgmtAuthConfig.port_group_type. A server may expose multiple slots
 * in the same port_group_type (e.g. EAST_WEST_BMC slots 1..8); each is
 * represented by a MgmtSlotBinding under `slot_bindings`. The optional
 * `default_credential` applies to every slot of this server unless a slot
 * supplies its own credential.
 */
export interface MgmtNodeBinding {
  /**
   * Either node_id or node_name identifies the server node. Exactly one is
   * required on the write path; both may be populated on the read path.
   */
  nodeId: string;
  nodeName: string;
  /**
   * Per-server default credential, applied to all slot_bindings (and any
   * uncovered slot of this server in the port group) unless overridden by
   * MgmtSlotBinding.credential. Resolution order, most specific first:
   *   1. MgmtSlotBinding.credential
   *   2. MgmtNodeBinding.default_credential
   *   3. MgmtAuthConfig.default_credential
   */
  defaultCredential:
    | MgmtCredential
    | undefined;
  /**
   * Per-slot management port settings (addressing + optional credential
   * override). One entry per physical slot the caller wants to configure.
   */
  slotBindings: MgmtSlotBinding[];
}

/**
 * MgmtSlotBinding represents a single management port (one slot) on a server.
 * Maps 1:1 with a server_mgmt_port row identified by the tuple
 * (node, MgmtAuthConfig.port_group_type, slot_number).
 */
export interface MgmtSlotBinding {
  /**
   * Slot number within the enclosing MgmtAuthConfig.port_group_type. See
   * device_model.server_port_groups[].slotNumbers in
   * cloud/schema/data/inventory/device-models.yml. For single-slot groups such
   * as BMC (slot [0]) this may be omitted. The (port_group_type, slot) pair
   * maps to server_mgmt_port rows whose `name` parses to the same index via
   * netutils.ParseServerMgmtPortName (e.g. "bmc0" -> 0, "bmc3" -> 3).
   */
  slotNumber: number;
  /** Optional IPv4 address override. Written to server_mgmt_port.ipv4_address. */
  ipv4Address: string;
  /**
   * Optional IPv6 address override. Written to server_mgmt_port.ipv6_address.
   * Either family may be supplied independently, or both for dual-stack.
   */
  ipv6Address: string;
  /**
   * OPTIONAL per-slot credential override. When omitted, the binding inherits
   * MgmtNodeBinding.default_credential (and, failing that,
   * MgmtAuthConfig.default_credential).
   */
  credential: MgmtCredential | undefined;
  credentialBinding: MgmtCredentialBinding;
}

export interface MgmtAuthConfig {
  serverGroupId: string;
  autoDiscovery: boolean;
  /**
   * Group-level default credential. Persisted as
   * server_group_connectivity_rule.default_credentials_id.
   */
  defaultCredential:
    | MgmtCredential
    | undefined;
  /**
   * Per-node port bindings. Omit MgmtNodeBinding.credential to inherit
   * default_credential.
   */
  nodeBindings: MgmtNodeBinding[];
  /**
   * Raw CSV content; backend parses rows into node_bindings.
   * Expected columns: server_name, slot_number, ipv4_address, ipv6_address,
   * username, password. When username/password are blank on a CSV row, the
   * binding inherits default_credential.
   */
  csvData: Uint8Array;
  portGroupType: ServerPortGroupType;
  connectivityRuleId: string;
}

export interface FabricBaseCloudConfig {
  fabricId: string;
  /** Committed location of fabric */
  location: string;
  /** Switch group information from fabric design */
  switchGroup: GroupBaseCloudConfig[];
  /** Server group information from fabric design */
  serverGroup: GroupBaseCloudConfig[];
  /** Migration status for fabric topology migration from v1 to v2 */
  migrationStatus: string;
  fabricSoftwareConfig: FabricSoftwareConfig | undefined;
}

export interface GroupBaseCloudConfig {
  /** Represents base_data from either switch or server group */
  baseData:
    | DesignObjectBaseData
    | undefined;
  /** Overall position of switch or server group */
  overallGroupPosition: number;
  /** List of the active_gpu nic slots. */
  activeGpuSlots: number[];
  /** The active_gpus bitmap describes which gpus are active. */
  activeGpuBitmap: number;
}

function createBaseIpmSetting(): IpmSetting {
  return { probeType: 0, ipmTargetId: "", ipmConfigId: "" };
}

export const IpmSetting: MessageFns<IpmSetting> = {
  encode(message: IpmSetting, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.probeType !== 0) {
      writer.uint32(8).int32(message.probeType);
    }
    if (message.ipmTargetId !== "") {
      writer.uint32(18).string(message.ipmTargetId);
    }
    if (message.ipmConfigId !== "") {
      writer.uint32(26).string(message.ipmConfigId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): IpmSetting {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseIpmSetting();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.probeType = reader.int32() as any;
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.ipmTargetId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.ipmConfigId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): IpmSetting {
    return {
      probeType: isSet(object.probeType) ? ipmProbeTypeFromJSON(object.probeType) : 0,
      ipmTargetId: isSet(object.ipmTargetId) ? globalThis.String(object.ipmTargetId) : "",
      ipmConfigId: isSet(object.ipmConfigId) ? globalThis.String(object.ipmConfigId) : "",
    };
  },

  toJSON(message: IpmSetting): unknown {
    const obj: any = {};
    if (message.probeType !== 0) {
      obj.probeType = ipmProbeTypeToJSON(message.probeType);
    }
    if (message.ipmTargetId !== "") {
      obj.ipmTargetId = message.ipmTargetId;
    }
    if (message.ipmConfigId !== "") {
      obj.ipmConfigId = message.ipmConfigId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<IpmSetting>, I>>(base?: I): IpmSetting {
    return IpmSetting.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<IpmSetting>, I>>(object: I): IpmSetting {
    const message = createBaseIpmSetting();
    message.probeType = object.probeType ?? 0;
    message.ipmTargetId = object.ipmTargetId ?? "";
    message.ipmConfigId = object.ipmConfigId ?? "";
    return message;
  },
};

function createBaseDesignObjectBaseData(): DesignObjectBaseData {
  return { name: "", id: "", shortName: "", position: 0, fabricId: "", nameAutoComputed: false };
}

export const DesignObjectBaseData: MessageFns<DesignObjectBaseData> = {
  encode(message: DesignObjectBaseData, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.name !== "") {
      writer.uint32(10).string(message.name);
    }
    if (message.id !== "") {
      writer.uint32(18).string(message.id);
    }
    if (message.shortName !== "") {
      writer.uint32(26).string(message.shortName);
    }
    if (message.position !== 0) {
      writer.uint32(32).uint32(message.position);
    }
    if (message.fabricId !== "") {
      writer.uint32(42).string(message.fabricId);
    }
    if (message.nameAutoComputed !== false) {
      writer.uint32(48).bool(message.nameAutoComputed);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DesignObjectBaseData {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDesignObjectBaseData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.shortName = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.position = reader.uint32();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.nameAutoComputed = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DesignObjectBaseData {
    return {
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      shortName: isSet(object.shortName) ? globalThis.String(object.shortName) : "",
      position: isSet(object.position) ? globalThis.Number(object.position) : 0,
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      nameAutoComputed: isSet(object.nameAutoComputed) ? globalThis.Boolean(object.nameAutoComputed) : false,
    };
  },

  toJSON(message: DesignObjectBaseData): unknown {
    const obj: any = {};
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.shortName !== "") {
      obj.shortName = message.shortName;
    }
    if (message.position !== 0) {
      obj.position = Math.round(message.position);
    }
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.nameAutoComputed !== false) {
      obj.nameAutoComputed = message.nameAutoComputed;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DesignObjectBaseData>, I>>(base?: I): DesignObjectBaseData {
    return DesignObjectBaseData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DesignObjectBaseData>, I>>(object: I): DesignObjectBaseData {
    const message = createBaseDesignObjectBaseData();
    message.name = object.name ?? "";
    message.id = object.id ?? "";
    message.shortName = object.shortName ?? "";
    message.position = object.position ?? 0;
    message.fabricId = object.fabricId ?? "";
    message.nameAutoComputed = object.nameAutoComputed ?? false;
    return message;
  },
};

function createBaseHwSet(): HwSet {
  return {
    baseData: undefined,
    setId: "",
    name: "",
    shortName: "",
    position: 0,
    fabricId: "",
    tierId: "",
    groupId: "",
    deviceModelName: "",
    psuModelName: "",
    airflowType: 0,
    nodes: [],
  };
}

export const HwSet: MessageFns<HwSet> = {
  encode(message: HwSet, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.baseData !== undefined) {
      DesignObjectBaseData.encode(message.baseData, writer.uint32(10).fork()).join();
    }
    if (message.setId !== "") {
      writer.uint32(82).string(message.setId);
    }
    if (message.name !== "") {
      writer.uint32(90).string(message.name);
    }
    if (message.shortName !== "") {
      writer.uint32(98).string(message.shortName);
    }
    if (message.position !== 0) {
      writer.uint32(104).uint32(message.position);
    }
    if (message.fabricId !== "") {
      writer.uint32(114).string(message.fabricId);
    }
    if (message.tierId !== "") {
      writer.uint32(122).string(message.tierId);
    }
    if (message.groupId !== "") {
      writer.uint32(130).string(message.groupId);
    }
    if (message.deviceModelName !== "") {
      writer.uint32(18).string(message.deviceModelName);
    }
    if (message.psuModelName !== "") {
      writer.uint32(26).string(message.psuModelName);
    }
    if (message.airflowType !== 0) {
      writer.uint32(32).int32(message.airflowType);
    }
    for (const v of message.nodes) {
      DesignObjectBaseData.encode(v!, writer.uint32(42).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): HwSet {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseHwSet();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.baseData = DesignObjectBaseData.decode(reader, reader.uint32());
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.setId = reader.string();
          continue;
        }
        case 11: {
          if (tag !== 90) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 12: {
          if (tag !== 98) {
            break;
          }

          message.shortName = reader.string();
          continue;
        }
        case 13: {
          if (tag !== 104) {
            break;
          }

          message.position = reader.uint32();
          continue;
        }
        case 14: {
          if (tag !== 114) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 15: {
          if (tag !== 122) {
            break;
          }

          message.tierId = reader.string();
          continue;
        }
        case 16: {
          if (tag !== 130) {
            break;
          }

          message.groupId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.deviceModelName = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.psuModelName = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.airflowType = reader.int32() as any;
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.nodes.push(DesignObjectBaseData.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): HwSet {
    return {
      baseData: isSet(object.baseData) ? DesignObjectBaseData.fromJSON(object.baseData) : undefined,
      setId: isSet(object.setId) ? globalThis.String(object.setId) : "",
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      shortName: isSet(object.shortName) ? globalThis.String(object.shortName) : "",
      position: isSet(object.position) ? globalThis.Number(object.position) : 0,
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      tierId: isSet(object.tierId) ? globalThis.String(object.tierId) : "",
      groupId: isSet(object.groupId) ? globalThis.String(object.groupId) : "",
      deviceModelName: isSet(object.deviceModelName) ? globalThis.String(object.deviceModelName) : "",
      psuModelName: isSet(object.psuModelName) ? globalThis.String(object.psuModelName) : "",
      airflowType: isSet(object.airflowType) ? airflowTypeFromJSON(object.airflowType) : 0,
      nodes: globalThis.Array.isArray(object?.nodes)
        ? object.nodes.map((e: any) => DesignObjectBaseData.fromJSON(e))
        : [],
    };
  },

  toJSON(message: HwSet): unknown {
    const obj: any = {};
    if (message.baseData !== undefined) {
      obj.baseData = DesignObjectBaseData.toJSON(message.baseData);
    }
    if (message.setId !== "") {
      obj.setId = message.setId;
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.shortName !== "") {
      obj.shortName = message.shortName;
    }
    if (message.position !== 0) {
      obj.position = Math.round(message.position);
    }
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.tierId !== "") {
      obj.tierId = message.tierId;
    }
    if (message.groupId !== "") {
      obj.groupId = message.groupId;
    }
    if (message.deviceModelName !== "") {
      obj.deviceModelName = message.deviceModelName;
    }
    if (message.psuModelName !== "") {
      obj.psuModelName = message.psuModelName;
    }
    if (message.airflowType !== 0) {
      obj.airflowType = airflowTypeToJSON(message.airflowType);
    }
    if (message.nodes?.length) {
      obj.nodes = message.nodes.map((e) => DesignObjectBaseData.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<HwSet>, I>>(base?: I): HwSet {
    return HwSet.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<HwSet>, I>>(object: I): HwSet {
    const message = createBaseHwSet();
    message.baseData = (object.baseData !== undefined && object.baseData !== null)
      ? DesignObjectBaseData.fromPartial(object.baseData)
      : undefined;
    message.setId = object.setId ?? "";
    message.name = object.name ?? "";
    message.shortName = object.shortName ?? "";
    message.position = object.position ?? 0;
    message.fabricId = object.fabricId ?? "";
    message.tierId = object.tierId ?? "";
    message.groupId = object.groupId ?? "";
    message.deviceModelName = object.deviceModelName ?? "";
    message.psuModelName = object.psuModelName ?? "";
    message.airflowType = object.airflowType ?? 0;
    message.nodes = object.nodes?.map((e) => DesignObjectBaseData.fromPartial(e)) || [];
    return message;
  },
};

function createBaseRail(): Rail {
  return { baseData: undefined, railId: "", name: "", shortName: "", position: 0, fabricId: "" };
}

export const Rail: MessageFns<Rail> = {
  encode(message: Rail, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.baseData !== undefined) {
      DesignObjectBaseData.encode(message.baseData, writer.uint32(10).fork()).join();
    }
    if (message.railId !== "") {
      writer.uint32(82).string(message.railId);
    }
    if (message.name !== "") {
      writer.uint32(90).string(message.name);
    }
    if (message.shortName !== "") {
      writer.uint32(98).string(message.shortName);
    }
    if (message.position !== 0) {
      writer.uint32(104).uint32(message.position);
    }
    if (message.fabricId !== "") {
      writer.uint32(114).string(message.fabricId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Rail {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRail();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.baseData = DesignObjectBaseData.decode(reader, reader.uint32());
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.railId = reader.string();
          continue;
        }
        case 11: {
          if (tag !== 90) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 12: {
          if (tag !== 98) {
            break;
          }

          message.shortName = reader.string();
          continue;
        }
        case 13: {
          if (tag !== 104) {
            break;
          }

          message.position = reader.uint32();
          continue;
        }
        case 14: {
          if (tag !== 114) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Rail {
    return {
      baseData: isSet(object.baseData) ? DesignObjectBaseData.fromJSON(object.baseData) : undefined,
      railId: isSet(object.railId) ? globalThis.String(object.railId) : "",
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      shortName: isSet(object.shortName) ? globalThis.String(object.shortName) : "",
      position: isSet(object.position) ? globalThis.Number(object.position) : 0,
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
    };
  },

  toJSON(message: Rail): unknown {
    const obj: any = {};
    if (message.baseData !== undefined) {
      obj.baseData = DesignObjectBaseData.toJSON(message.baseData);
    }
    if (message.railId !== "") {
      obj.railId = message.railId;
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.shortName !== "") {
      obj.shortName = message.shortName;
    }
    if (message.position !== 0) {
      obj.position = Math.round(message.position);
    }
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Rail>, I>>(base?: I): Rail {
    return Rail.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Rail>, I>>(object: I): Rail {
    const message = createBaseRail();
    message.baseData = (object.baseData !== undefined && object.baseData !== null)
      ? DesignObjectBaseData.fromPartial(object.baseData)
      : undefined;
    message.railId = object.railId ?? "";
    message.name = object.name ?? "";
    message.shortName = object.shortName ?? "";
    message.position = object.position ?? 0;
    message.fabricId = object.fabricId ?? "";
    return message;
  },
};

function createBaseRailGroup(): RailGroup {
  return {
    baseData: undefined,
    groupId: "",
    name: "",
    shortName: "",
    position: 0,
    fabricId: "",
    count: 0,
    switchGroupId: "",
    strategy: 0,
    overallGroupPosition: 0,
    railWidth: 0,
    rails: [],
    widthAutoComputed: false,
    countAutoComputed: false,
  };
}

export const RailGroup: MessageFns<RailGroup> = {
  encode(message: RailGroup, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.baseData !== undefined) {
      DesignObjectBaseData.encode(message.baseData, writer.uint32(10).fork()).join();
    }
    if (message.groupId !== "") {
      writer.uint32(82).string(message.groupId);
    }
    if (message.name !== "") {
      writer.uint32(90).string(message.name);
    }
    if (message.shortName !== "") {
      writer.uint32(98).string(message.shortName);
    }
    if (message.position !== 0) {
      writer.uint32(104).uint32(message.position);
    }
    if (message.fabricId !== "") {
      writer.uint32(114).string(message.fabricId);
    }
    if (message.count !== 0) {
      writer.uint32(16).uint32(message.count);
    }
    if (message.switchGroupId !== "") {
      writer.uint32(26).string(message.switchGroupId);
    }
    if (message.strategy !== 0) {
      writer.uint32(32).int32(message.strategy);
    }
    if (message.overallGroupPosition !== 0) {
      writer.uint32(40).uint32(message.overallGroupPosition);
    }
    if (message.railWidth !== 0) {
      writer.uint32(48).uint32(message.railWidth);
    }
    for (const v of message.rails) {
      Rail.encode(v!, writer.uint32(58).fork()).join();
    }
    if (message.widthAutoComputed !== false) {
      writer.uint32(64).bool(message.widthAutoComputed);
    }
    if (message.countAutoComputed !== false) {
      writer.uint32(72).bool(message.countAutoComputed);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RailGroup {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRailGroup();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.baseData = DesignObjectBaseData.decode(reader, reader.uint32());
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.groupId = reader.string();
          continue;
        }
        case 11: {
          if (tag !== 90) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 12: {
          if (tag !== 98) {
            break;
          }

          message.shortName = reader.string();
          continue;
        }
        case 13: {
          if (tag !== 104) {
            break;
          }

          message.position = reader.uint32();
          continue;
        }
        case 14: {
          if (tag !== 114) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.count = reader.uint32();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.switchGroupId = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.strategy = reader.int32() as any;
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.overallGroupPosition = reader.uint32();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.railWidth = reader.uint32();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.rails.push(Rail.decode(reader, reader.uint32()));
          continue;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.widthAutoComputed = reader.bool();
          continue;
        }
        case 9: {
          if (tag !== 72) {
            break;
          }

          message.countAutoComputed = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): RailGroup {
    return {
      baseData: isSet(object.baseData) ? DesignObjectBaseData.fromJSON(object.baseData) : undefined,
      groupId: isSet(object.groupId) ? globalThis.String(object.groupId) : "",
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      shortName: isSet(object.shortName) ? globalThis.String(object.shortName) : "",
      position: isSet(object.position) ? globalThis.Number(object.position) : 0,
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      count: isSet(object.count) ? globalThis.Number(object.count) : 0,
      switchGroupId: isSet(object.switchGroupId) ? globalThis.String(object.switchGroupId) : "",
      strategy: isSet(object.strategy) ? placementStrategyFromJSON(object.strategy) : 0,
      overallGroupPosition: isSet(object.overallGroupPosition) ? globalThis.Number(object.overallGroupPosition) : 0,
      railWidth: isSet(object.railWidth) ? globalThis.Number(object.railWidth) : 0,
      rails: globalThis.Array.isArray(object?.rails) ? object.rails.map((e: any) => Rail.fromJSON(e)) : [],
      widthAutoComputed: isSet(object.widthAutoComputed) ? globalThis.Boolean(object.widthAutoComputed) : false,
      countAutoComputed: isSet(object.countAutoComputed) ? globalThis.Boolean(object.countAutoComputed) : false,
    };
  },

  toJSON(message: RailGroup): unknown {
    const obj: any = {};
    if (message.baseData !== undefined) {
      obj.baseData = DesignObjectBaseData.toJSON(message.baseData);
    }
    if (message.groupId !== "") {
      obj.groupId = message.groupId;
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.shortName !== "") {
      obj.shortName = message.shortName;
    }
    if (message.position !== 0) {
      obj.position = Math.round(message.position);
    }
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.count !== 0) {
      obj.count = Math.round(message.count);
    }
    if (message.switchGroupId !== "") {
      obj.switchGroupId = message.switchGroupId;
    }
    if (message.strategy !== 0) {
      obj.strategy = placementStrategyToJSON(message.strategy);
    }
    if (message.overallGroupPosition !== 0) {
      obj.overallGroupPosition = Math.round(message.overallGroupPosition);
    }
    if (message.railWidth !== 0) {
      obj.railWidth = Math.round(message.railWidth);
    }
    if (message.rails?.length) {
      obj.rails = message.rails.map((e) => Rail.toJSON(e));
    }
    if (message.widthAutoComputed !== false) {
      obj.widthAutoComputed = message.widthAutoComputed;
    }
    if (message.countAutoComputed !== false) {
      obj.countAutoComputed = message.countAutoComputed;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<RailGroup>, I>>(base?: I): RailGroup {
    return RailGroup.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<RailGroup>, I>>(object: I): RailGroup {
    const message = createBaseRailGroup();
    message.baseData = (object.baseData !== undefined && object.baseData !== null)
      ? DesignObjectBaseData.fromPartial(object.baseData)
      : undefined;
    message.groupId = object.groupId ?? "";
    message.name = object.name ?? "";
    message.shortName = object.shortName ?? "";
    message.position = object.position ?? 0;
    message.fabricId = object.fabricId ?? "";
    message.count = object.count ?? 0;
    message.switchGroupId = object.switchGroupId ?? "";
    message.strategy = object.strategy ?? 0;
    message.overallGroupPosition = object.overallGroupPosition ?? 0;
    message.railWidth = object.railWidth ?? 0;
    message.rails = object.rails?.map((e) => Rail.fromPartial(e)) || [];
    message.widthAutoComputed = object.widthAutoComputed ?? false;
    message.countAutoComputed = object.countAutoComputed ?? false;
    return message;
  },
};

function createBaseSwitchGroup(): SwitchGroup {
  return {
    baseData: undefined,
    groupId: "",
    name: "",
    shortName: "",
    position: 0,
    fabricId: "",
    tierId: "",
    baseModelName: "",
    overallGroupPosition: 0,
    hwSets: [],
    monitored: false,
    osType: 0,
    enableArs: false,
    enableAutoPort: false,
  };
}

export const SwitchGroup: MessageFns<SwitchGroup> = {
  encode(message: SwitchGroup, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.baseData !== undefined) {
      DesignObjectBaseData.encode(message.baseData, writer.uint32(10).fork()).join();
    }
    if (message.groupId !== "") {
      writer.uint32(82).string(message.groupId);
    }
    if (message.name !== "") {
      writer.uint32(90).string(message.name);
    }
    if (message.shortName !== "") {
      writer.uint32(98).string(message.shortName);
    }
    if (message.position !== 0) {
      writer.uint32(104).uint32(message.position);
    }
    if (message.fabricId !== "") {
      writer.uint32(114).string(message.fabricId);
    }
    if (message.tierId !== "") {
      writer.uint32(122).string(message.tierId);
    }
    if (message.baseModelName !== "") {
      writer.uint32(18).string(message.baseModelName);
    }
    if (message.overallGroupPosition !== 0) {
      writer.uint32(24).uint32(message.overallGroupPosition);
    }
    for (const v of message.hwSets) {
      HwSet.encode(v!, writer.uint32(34).fork()).join();
    }
    if (message.monitored !== false) {
      writer.uint32(40).bool(message.monitored);
    }
    if (message.osType !== 0) {
      writer.uint32(48).int32(message.osType);
    }
    if (message.enableArs !== false) {
      writer.uint32(56).bool(message.enableArs);
    }
    if (message.enableAutoPort !== false) {
      writer.uint32(64).bool(message.enableAutoPort);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SwitchGroup {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSwitchGroup();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.baseData = DesignObjectBaseData.decode(reader, reader.uint32());
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.groupId = reader.string();
          continue;
        }
        case 11: {
          if (tag !== 90) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 12: {
          if (tag !== 98) {
            break;
          }

          message.shortName = reader.string();
          continue;
        }
        case 13: {
          if (tag !== 104) {
            break;
          }

          message.position = reader.uint32();
          continue;
        }
        case 14: {
          if (tag !== 114) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 15: {
          if (tag !== 122) {
            break;
          }

          message.tierId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.baseModelName = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.overallGroupPosition = reader.uint32();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.hwSets.push(HwSet.decode(reader, reader.uint32()));
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.monitored = reader.bool();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.osType = reader.int32() as any;
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.enableArs = reader.bool();
          continue;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.enableAutoPort = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SwitchGroup {
    return {
      baseData: isSet(object.baseData) ? DesignObjectBaseData.fromJSON(object.baseData) : undefined,
      groupId: isSet(object.groupId) ? globalThis.String(object.groupId) : "",
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      shortName: isSet(object.shortName) ? globalThis.String(object.shortName) : "",
      position: isSet(object.position) ? globalThis.Number(object.position) : 0,
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      tierId: isSet(object.tierId) ? globalThis.String(object.tierId) : "",
      baseModelName: isSet(object.baseModelName) ? globalThis.String(object.baseModelName) : "",
      overallGroupPosition: isSet(object.overallGroupPosition) ? globalThis.Number(object.overallGroupPosition) : 0,
      hwSets: globalThis.Array.isArray(object?.hwSets) ? object.hwSets.map((e: any) => HwSet.fromJSON(e)) : [],
      monitored: isSet(object.monitored) ? globalThis.Boolean(object.monitored) : false,
      osType: isSet(object.osType) ? osTypeFromJSON(object.osType) : 0,
      enableArs: isSet(object.enableArs) ? globalThis.Boolean(object.enableArs) : false,
      enableAutoPort: isSet(object.enableAutoPort) ? globalThis.Boolean(object.enableAutoPort) : false,
    };
  },

  toJSON(message: SwitchGroup): unknown {
    const obj: any = {};
    if (message.baseData !== undefined) {
      obj.baseData = DesignObjectBaseData.toJSON(message.baseData);
    }
    if (message.groupId !== "") {
      obj.groupId = message.groupId;
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.shortName !== "") {
      obj.shortName = message.shortName;
    }
    if (message.position !== 0) {
      obj.position = Math.round(message.position);
    }
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.tierId !== "") {
      obj.tierId = message.tierId;
    }
    if (message.baseModelName !== "") {
      obj.baseModelName = message.baseModelName;
    }
    if (message.overallGroupPosition !== 0) {
      obj.overallGroupPosition = Math.round(message.overallGroupPosition);
    }
    if (message.hwSets?.length) {
      obj.hwSets = message.hwSets.map((e) => HwSet.toJSON(e));
    }
    if (message.monitored !== false) {
      obj.monitored = message.monitored;
    }
    if (message.osType !== 0) {
      obj.osType = osTypeToJSON(message.osType);
    }
    if (message.enableArs !== false) {
      obj.enableArs = message.enableArs;
    }
    if (message.enableAutoPort !== false) {
      obj.enableAutoPort = message.enableAutoPort;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SwitchGroup>, I>>(base?: I): SwitchGroup {
    return SwitchGroup.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SwitchGroup>, I>>(object: I): SwitchGroup {
    const message = createBaseSwitchGroup();
    message.baseData = (object.baseData !== undefined && object.baseData !== null)
      ? DesignObjectBaseData.fromPartial(object.baseData)
      : undefined;
    message.groupId = object.groupId ?? "";
    message.name = object.name ?? "";
    message.shortName = object.shortName ?? "";
    message.position = object.position ?? 0;
    message.fabricId = object.fabricId ?? "";
    message.tierId = object.tierId ?? "";
    message.baseModelName = object.baseModelName ?? "";
    message.overallGroupPosition = object.overallGroupPosition ?? 0;
    message.hwSets = object.hwSets?.map((e) => HwSet.fromPartial(e)) || [];
    message.monitored = object.monitored ?? false;
    message.osType = object.osType ?? 0;
    message.enableArs = object.enableArs ?? false;
    message.enableAutoPort = object.enableAutoPort ?? false;
    return message;
  },
};

function createBaseServerGroup(): ServerGroup {
  return {
    baseData: undefined,
    groupId: "",
    name: "",
    shortName: "",
    position: 0,
    fabricId: "",
    tierId: "",
    baseModelName: "",
    overallGroupPosition: 0,
    hwSets: [],
    activeGpus: 0,
    internalLabels: [],
  };
}

export const ServerGroup: MessageFns<ServerGroup> = {
  encode(message: ServerGroup, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.baseData !== undefined) {
      DesignObjectBaseData.encode(message.baseData, writer.uint32(10).fork()).join();
    }
    if (message.groupId !== "") {
      writer.uint32(82).string(message.groupId);
    }
    if (message.name !== "") {
      writer.uint32(90).string(message.name);
    }
    if (message.shortName !== "") {
      writer.uint32(98).string(message.shortName);
    }
    if (message.position !== 0) {
      writer.uint32(104).uint32(message.position);
    }
    if (message.fabricId !== "") {
      writer.uint32(114).string(message.fabricId);
    }
    if (message.tierId !== "") {
      writer.uint32(122).string(message.tierId);
    }
    if (message.baseModelName !== "") {
      writer.uint32(18).string(message.baseModelName);
    }
    if (message.overallGroupPosition !== 0) {
      writer.uint32(24).uint32(message.overallGroupPosition);
    }
    for (const v of message.hwSets) {
      HwSet.encode(v!, writer.uint32(34).fork()).join();
    }
    if (message.activeGpus !== 0) {
      writer.uint32(128).uint32(message.activeGpus);
    }
    for (const v of message.internalLabels) {
      writer.uint32(138).string(v!);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ServerGroup {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseServerGroup();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.baseData = DesignObjectBaseData.decode(reader, reader.uint32());
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.groupId = reader.string();
          continue;
        }
        case 11: {
          if (tag !== 90) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 12: {
          if (tag !== 98) {
            break;
          }

          message.shortName = reader.string();
          continue;
        }
        case 13: {
          if (tag !== 104) {
            break;
          }

          message.position = reader.uint32();
          continue;
        }
        case 14: {
          if (tag !== 114) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 15: {
          if (tag !== 122) {
            break;
          }

          message.tierId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.baseModelName = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.overallGroupPosition = reader.uint32();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.hwSets.push(HwSet.decode(reader, reader.uint32()));
          continue;
        }
        case 16: {
          if (tag !== 128) {
            break;
          }

          message.activeGpus = reader.uint32();
          continue;
        }
        case 17: {
          if (tag !== 138) {
            break;
          }

          message.internalLabels.push(reader.string());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ServerGroup {
    return {
      baseData: isSet(object.baseData) ? DesignObjectBaseData.fromJSON(object.baseData) : undefined,
      groupId: isSet(object.groupId) ? globalThis.String(object.groupId) : "",
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      shortName: isSet(object.shortName) ? globalThis.String(object.shortName) : "",
      position: isSet(object.position) ? globalThis.Number(object.position) : 0,
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      tierId: isSet(object.tierId) ? globalThis.String(object.tierId) : "",
      baseModelName: isSet(object.baseModelName) ? globalThis.String(object.baseModelName) : "",
      overallGroupPosition: isSet(object.overallGroupPosition) ? globalThis.Number(object.overallGroupPosition) : 0,
      hwSets: globalThis.Array.isArray(object?.hwSets) ? object.hwSets.map((e: any) => HwSet.fromJSON(e)) : [],
      activeGpus: isSet(object.activeGpus) ? globalThis.Number(object.activeGpus) : 0,
      internalLabels: globalThis.Array.isArray(object?.internalLabels)
        ? object.internalLabels.map((e: any) => globalThis.String(e))
        : [],
    };
  },

  toJSON(message: ServerGroup): unknown {
    const obj: any = {};
    if (message.baseData !== undefined) {
      obj.baseData = DesignObjectBaseData.toJSON(message.baseData);
    }
    if (message.groupId !== "") {
      obj.groupId = message.groupId;
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.shortName !== "") {
      obj.shortName = message.shortName;
    }
    if (message.position !== 0) {
      obj.position = Math.round(message.position);
    }
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.tierId !== "") {
      obj.tierId = message.tierId;
    }
    if (message.baseModelName !== "") {
      obj.baseModelName = message.baseModelName;
    }
    if (message.overallGroupPosition !== 0) {
      obj.overallGroupPosition = Math.round(message.overallGroupPosition);
    }
    if (message.hwSets?.length) {
      obj.hwSets = message.hwSets.map((e) => HwSet.toJSON(e));
    }
    if (message.activeGpus !== 0) {
      obj.activeGpus = Math.round(message.activeGpus);
    }
    if (message.internalLabels?.length) {
      obj.internalLabels = message.internalLabels;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ServerGroup>, I>>(base?: I): ServerGroup {
    return ServerGroup.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ServerGroup>, I>>(object: I): ServerGroup {
    const message = createBaseServerGroup();
    message.baseData = (object.baseData !== undefined && object.baseData !== null)
      ? DesignObjectBaseData.fromPartial(object.baseData)
      : undefined;
    message.groupId = object.groupId ?? "";
    message.name = object.name ?? "";
    message.shortName = object.shortName ?? "";
    message.position = object.position ?? 0;
    message.fabricId = object.fabricId ?? "";
    message.tierId = object.tierId ?? "";
    message.baseModelName = object.baseModelName ?? "";
    message.overallGroupPosition = object.overallGroupPosition ?? 0;
    message.hwSets = object.hwSets?.map((e) => HwSet.fromPartial(e)) || [];
    message.activeGpus = object.activeGpus ?? 0;
    message.internalLabels = object.internalLabels?.map((e) => e) || [];
    return message;
  },
};

function createBaseTier(): Tier {
  return {
    baseData: undefined,
    tierId: "",
    name: "",
    shortName: "",
    position: 0,
    fabricId: "",
    allowedGroupTypes: [],
    serverGroups: [],
    switchGroups: [],
  };
}

export const Tier: MessageFns<Tier> = {
  encode(message: Tier, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.baseData !== undefined) {
      DesignObjectBaseData.encode(message.baseData, writer.uint32(10).fork()).join();
    }
    if (message.tierId !== "") {
      writer.uint32(82).string(message.tierId);
    }
    if (message.name !== "") {
      writer.uint32(90).string(message.name);
    }
    if (message.shortName !== "") {
      writer.uint32(98).string(message.shortName);
    }
    if (message.position !== 0) {
      writer.uint32(104).uint32(message.position);
    }
    if (message.fabricId !== "") {
      writer.uint32(114).string(message.fabricId);
    }
    writer.uint32(18).fork();
    for (const v of message.allowedGroupTypes) {
      writer.int32(v);
    }
    writer.join();
    for (const v of message.serverGroups) {
      ServerGroup.encode(v!, writer.uint32(26).fork()).join();
    }
    for (const v of message.switchGroups) {
      SwitchGroup.encode(v!, writer.uint32(34).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Tier {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTier();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.baseData = DesignObjectBaseData.decode(reader, reader.uint32());
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.tierId = reader.string();
          continue;
        }
        case 11: {
          if (tag !== 90) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 12: {
          if (tag !== 98) {
            break;
          }

          message.shortName = reader.string();
          continue;
        }
        case 13: {
          if (tag !== 104) {
            break;
          }

          message.position = reader.uint32();
          continue;
        }
        case 14: {
          if (tag !== 114) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 2: {
          if (tag === 16) {
            message.allowedGroupTypes.push(reader.int32() as any);

            continue;
          }

          if (tag === 18) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.allowedGroupTypes.push(reader.int32() as any);
            }

            continue;
          }

          break;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.serverGroups.push(ServerGroup.decode(reader, reader.uint32()));
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.switchGroups.push(SwitchGroup.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Tier {
    return {
      baseData: isSet(object.baseData) ? DesignObjectBaseData.fromJSON(object.baseData) : undefined,
      tierId: isSet(object.tierId) ? globalThis.String(object.tierId) : "",
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      shortName: isSet(object.shortName) ? globalThis.String(object.shortName) : "",
      position: isSet(object.position) ? globalThis.Number(object.position) : 0,
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      allowedGroupTypes: globalThis.Array.isArray(object?.allowedGroupTypes)
        ? object.allowedGroupTypes.map((e: any) => topologyGroupTypeFromJSON(e))
        : [],
      serverGroups: globalThis.Array.isArray(object?.serverGroups)
        ? object.serverGroups.map((e: any) => ServerGroup.fromJSON(e))
        : [],
      switchGroups: globalThis.Array.isArray(object?.switchGroups)
        ? object.switchGroups.map((e: any) => SwitchGroup.fromJSON(e))
        : [],
    };
  },

  toJSON(message: Tier): unknown {
    const obj: any = {};
    if (message.baseData !== undefined) {
      obj.baseData = DesignObjectBaseData.toJSON(message.baseData);
    }
    if (message.tierId !== "") {
      obj.tierId = message.tierId;
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.shortName !== "") {
      obj.shortName = message.shortName;
    }
    if (message.position !== 0) {
      obj.position = Math.round(message.position);
    }
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.allowedGroupTypes?.length) {
      obj.allowedGroupTypes = message.allowedGroupTypes.map((e) => topologyGroupTypeToJSON(e));
    }
    if (message.serverGroups?.length) {
      obj.serverGroups = message.serverGroups.map((e) => ServerGroup.toJSON(e));
    }
    if (message.switchGroups?.length) {
      obj.switchGroups = message.switchGroups.map((e) => SwitchGroup.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Tier>, I>>(base?: I): Tier {
    return Tier.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Tier>, I>>(object: I): Tier {
    const message = createBaseTier();
    message.baseData = (object.baseData !== undefined && object.baseData !== null)
      ? DesignObjectBaseData.fromPartial(object.baseData)
      : undefined;
    message.tierId = object.tierId ?? "";
    message.name = object.name ?? "";
    message.shortName = object.shortName ?? "";
    message.position = object.position ?? 0;
    message.fabricId = object.fabricId ?? "";
    message.allowedGroupTypes = object.allowedGroupTypes?.map((e) => e) || [];
    message.serverGroups = object.serverGroups?.map((e) => ServerGroup.fromPartial(e)) || [];
    message.switchGroups = object.switchGroups?.map((e) => SwitchGroup.fromPartial(e)) || [];
    return message;
  },
};

function createBaseSwitchGroupConnectivityRule(): SwitchGroupConnectivityRule {
  return {
    ruleId: "",
    switchGroup1Id: "",
    switchGroup1PluggablePid: "",
    cablePid: "",
    switchGroup1Breakout: false,
    switchGroup2Id: "",
    switchGroup2PluggablePid: "",
    switchGroup2Breakout: false,
    numDirectConnections: 0,
    strategy: 0,
    ipmProbes: [],
    mtu: 0,
    fec: "",
    notes: "",
  };
}

export const SwitchGroupConnectivityRule: MessageFns<SwitchGroupConnectivityRule> = {
  encode(message: SwitchGroupConnectivityRule, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.ruleId !== "") {
      writer.uint32(10).string(message.ruleId);
    }
    if (message.switchGroup1Id !== "") {
      writer.uint32(18).string(message.switchGroup1Id);
    }
    if (message.switchGroup1PluggablePid !== "") {
      writer.uint32(26).string(message.switchGroup1PluggablePid);
    }
    if (message.cablePid !== "") {
      writer.uint32(34).string(message.cablePid);
    }
    if (message.switchGroup1Breakout !== false) {
      writer.uint32(40).bool(message.switchGroup1Breakout);
    }
    if (message.switchGroup2Id !== "") {
      writer.uint32(50).string(message.switchGroup2Id);
    }
    if (message.switchGroup2PluggablePid !== "") {
      writer.uint32(58).string(message.switchGroup2PluggablePid);
    }
    if (message.switchGroup2Breakout !== false) {
      writer.uint32(64).bool(message.switchGroup2Breakout);
    }
    if (message.numDirectConnections !== 0) {
      writer.uint32(72).uint32(message.numDirectConnections);
    }
    if (message.strategy !== 0) {
      writer.uint32(80).int32(message.strategy);
    }
    for (const v of message.ipmProbes) {
      IpmSetting.encode(v!, writer.uint32(90).fork()).join();
    }
    if (message.mtu !== 0) {
      writer.uint32(96).uint32(message.mtu);
    }
    if (message.fec !== "") {
      writer.uint32(106).string(message.fec);
    }
    if (message.notes !== "") {
      writer.uint32(122).string(message.notes);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SwitchGroupConnectivityRule {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSwitchGroupConnectivityRule();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.ruleId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.switchGroup1Id = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.switchGroup1PluggablePid = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.cablePid = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.switchGroup1Breakout = reader.bool();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.switchGroup2Id = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.switchGroup2PluggablePid = reader.string();
          continue;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.switchGroup2Breakout = reader.bool();
          continue;
        }
        case 9: {
          if (tag !== 72) {
            break;
          }

          message.numDirectConnections = reader.uint32();
          continue;
        }
        case 10: {
          if (tag !== 80) {
            break;
          }

          message.strategy = reader.int32() as any;
          continue;
        }
        case 11: {
          if (tag !== 90) {
            break;
          }

          message.ipmProbes.push(IpmSetting.decode(reader, reader.uint32()));
          continue;
        }
        case 12: {
          if (tag !== 96) {
            break;
          }

          message.mtu = reader.uint32();
          continue;
        }
        case 13: {
          if (tag !== 106) {
            break;
          }

          message.fec = reader.string();
          continue;
        }
        case 15: {
          if (tag !== 122) {
            break;
          }

          message.notes = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SwitchGroupConnectivityRule {
    return {
      ruleId: isSet(object.ruleId) ? globalThis.String(object.ruleId) : "",
      switchGroup1Id: isSet(object.switchGroup1Id) ? globalThis.String(object.switchGroup1Id) : "",
      switchGroup1PluggablePid: isSet(object.switchGroup1PluggablePid)
        ? globalThis.String(object.switchGroup1PluggablePid)
        : "",
      cablePid: isSet(object.cablePid) ? globalThis.String(object.cablePid) : "",
      switchGroup1Breakout: isSet(object.switchGroup1Breakout)
        ? globalThis.Boolean(object.switchGroup1Breakout)
        : false,
      switchGroup2Id: isSet(object.switchGroup2Id) ? globalThis.String(object.switchGroup2Id) : "",
      switchGroup2PluggablePid: isSet(object.switchGroup2PluggablePid)
        ? globalThis.String(object.switchGroup2PluggablePid)
        : "",
      switchGroup2Breakout: isSet(object.switchGroup2Breakout)
        ? globalThis.Boolean(object.switchGroup2Breakout)
        : false,
      numDirectConnections: isSet(object.numDirectConnections) ? globalThis.Number(object.numDirectConnections) : 0,
      strategy: isSet(object.strategy) ? cablingStrategyFromJSON(object.strategy) : 0,
      ipmProbes: globalThis.Array.isArray(object?.ipmProbes)
        ? object.ipmProbes.map((e: any) => IpmSetting.fromJSON(e))
        : [],
      mtu: isSet(object.mtu) ? globalThis.Number(object.mtu) : 0,
      fec: isSet(object.fec) ? globalThis.String(object.fec) : "",
      notes: isSet(object.notes) ? globalThis.String(object.notes) : "",
    };
  },

  toJSON(message: SwitchGroupConnectivityRule): unknown {
    const obj: any = {};
    if (message.ruleId !== "") {
      obj.ruleId = message.ruleId;
    }
    if (message.switchGroup1Id !== "") {
      obj.switchGroup1Id = message.switchGroup1Id;
    }
    if (message.switchGroup1PluggablePid !== "") {
      obj.switchGroup1PluggablePid = message.switchGroup1PluggablePid;
    }
    if (message.cablePid !== "") {
      obj.cablePid = message.cablePid;
    }
    if (message.switchGroup1Breakout !== false) {
      obj.switchGroup1Breakout = message.switchGroup1Breakout;
    }
    if (message.switchGroup2Id !== "") {
      obj.switchGroup2Id = message.switchGroup2Id;
    }
    if (message.switchGroup2PluggablePid !== "") {
      obj.switchGroup2PluggablePid = message.switchGroup2PluggablePid;
    }
    if (message.switchGroup2Breakout !== false) {
      obj.switchGroup2Breakout = message.switchGroup2Breakout;
    }
    if (message.numDirectConnections !== 0) {
      obj.numDirectConnections = Math.round(message.numDirectConnections);
    }
    if (message.strategy !== 0) {
      obj.strategy = cablingStrategyToJSON(message.strategy);
    }
    if (message.ipmProbes?.length) {
      obj.ipmProbes = message.ipmProbes.map((e) => IpmSetting.toJSON(e));
    }
    if (message.mtu !== 0) {
      obj.mtu = Math.round(message.mtu);
    }
    if (message.fec !== "") {
      obj.fec = message.fec;
    }
    if (message.notes !== "") {
      obj.notes = message.notes;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SwitchGroupConnectivityRule>, I>>(base?: I): SwitchGroupConnectivityRule {
    return SwitchGroupConnectivityRule.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SwitchGroupConnectivityRule>, I>>(object: I): SwitchGroupConnectivityRule {
    const message = createBaseSwitchGroupConnectivityRule();
    message.ruleId = object.ruleId ?? "";
    message.switchGroup1Id = object.switchGroup1Id ?? "";
    message.switchGroup1PluggablePid = object.switchGroup1PluggablePid ?? "";
    message.cablePid = object.cablePid ?? "";
    message.switchGroup1Breakout = object.switchGroup1Breakout ?? false;
    message.switchGroup2Id = object.switchGroup2Id ?? "";
    message.switchGroup2PluggablePid = object.switchGroup2PluggablePid ?? "";
    message.switchGroup2Breakout = object.switchGroup2Breakout ?? false;
    message.numDirectConnections = object.numDirectConnections ?? 0;
    message.strategy = object.strategy ?? 0;
    message.ipmProbes = object.ipmProbes?.map((e) => IpmSetting.fromPartial(e)) || [];
    message.mtu = object.mtu ?? 0;
    message.fec = object.fec ?? "";
    message.notes = object.notes ?? "";
    return message;
  },
};

function createBaseServerGroupConnectivityRule(): ServerGroupConnectivityRule {
  return {
    ruleId: "",
    serverGroupId: "",
    serverGroupPluggablePid: "",
    cablePid: "",
    switchGroupId: "",
    switchGroupPluggablePid: "",
    switchGroupBreakout: false,
    railGroupId: "",
    numDirectConnections: 0,
    portGroupType: 0,
    strategy: 0,
    ipmProbes: [],
    notes: "",
    portSetId: 0,
    mtu: 0,
    fec: "",
    torTrayIds: [],
    serverTrayModelName: "",
  };
}

export const ServerGroupConnectivityRule: MessageFns<ServerGroupConnectivityRule> = {
  encode(message: ServerGroupConnectivityRule, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.ruleId !== "") {
      writer.uint32(10).string(message.ruleId);
    }
    if (message.serverGroupId !== "") {
      writer.uint32(18).string(message.serverGroupId);
    }
    if (message.serverGroupPluggablePid !== "") {
      writer.uint32(26).string(message.serverGroupPluggablePid);
    }
    if (message.cablePid !== "") {
      writer.uint32(34).string(message.cablePid);
    }
    if (message.switchGroupId !== "") {
      writer.uint32(42).string(message.switchGroupId);
    }
    if (message.switchGroupPluggablePid !== "") {
      writer.uint32(50).string(message.switchGroupPluggablePid);
    }
    if (message.switchGroupBreakout !== false) {
      writer.uint32(56).bool(message.switchGroupBreakout);
    }
    if (message.railGroupId !== "") {
      writer.uint32(66).string(message.railGroupId);
    }
    if (message.numDirectConnections !== 0) {
      writer.uint32(72).uint32(message.numDirectConnections);
    }
    if (message.portGroupType !== 0) {
      writer.uint32(80).int32(message.portGroupType);
    }
    if (message.strategy !== 0) {
      writer.uint32(88).int32(message.strategy);
    }
    for (const v of message.ipmProbes) {
      IpmSetting.encode(v!, writer.uint32(106).fork()).join();
    }
    if (message.notes !== "") {
      writer.uint32(122).string(message.notes);
    }
    if (message.portSetId !== 0) {
      writer.uint32(128).uint32(message.portSetId);
    }
    if (message.mtu !== 0) {
      writer.uint32(136).uint32(message.mtu);
    }
    if (message.fec !== "") {
      writer.uint32(146).string(message.fec);
    }
    writer.uint32(154).fork();
    for (const v of message.torTrayIds) {
      writer.uint32(v);
    }
    writer.join();
    if (message.serverTrayModelName !== "") {
      writer.uint32(162).string(message.serverTrayModelName);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ServerGroupConnectivityRule {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseServerGroupConnectivityRule();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.ruleId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.serverGroupId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.serverGroupPluggablePid = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.cablePid = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.switchGroupId = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.switchGroupPluggablePid = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.switchGroupBreakout = reader.bool();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.railGroupId = reader.string();
          continue;
        }
        case 9: {
          if (tag !== 72) {
            break;
          }

          message.numDirectConnections = reader.uint32();
          continue;
        }
        case 10: {
          if (tag !== 80) {
            break;
          }

          message.portGroupType = reader.int32() as any;
          continue;
        }
        case 11: {
          if (tag !== 88) {
            break;
          }

          message.strategy = reader.int32() as any;
          continue;
        }
        case 13: {
          if (tag !== 106) {
            break;
          }

          message.ipmProbes.push(IpmSetting.decode(reader, reader.uint32()));
          continue;
        }
        case 15: {
          if (tag !== 122) {
            break;
          }

          message.notes = reader.string();
          continue;
        }
        case 16: {
          if (tag !== 128) {
            break;
          }

          message.portSetId = reader.uint32();
          continue;
        }
        case 17: {
          if (tag !== 136) {
            break;
          }

          message.mtu = reader.uint32();
          continue;
        }
        case 18: {
          if (tag !== 146) {
            break;
          }

          message.fec = reader.string();
          continue;
        }
        case 19: {
          if (tag === 152) {
            message.torTrayIds.push(reader.uint32());

            continue;
          }

          if (tag === 154) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.torTrayIds.push(reader.uint32());
            }

            continue;
          }

          break;
        }
        case 20: {
          if (tag !== 162) {
            break;
          }

          message.serverTrayModelName = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ServerGroupConnectivityRule {
    return {
      ruleId: isSet(object.ruleId) ? globalThis.String(object.ruleId) : "",
      serverGroupId: isSet(object.serverGroupId) ? globalThis.String(object.serverGroupId) : "",
      serverGroupPluggablePid: isSet(object.serverGroupPluggablePid)
        ? globalThis.String(object.serverGroupPluggablePid)
        : "",
      cablePid: isSet(object.cablePid) ? globalThis.String(object.cablePid) : "",
      switchGroupId: isSet(object.switchGroupId) ? globalThis.String(object.switchGroupId) : "",
      switchGroupPluggablePid: isSet(object.switchGroupPluggablePid)
        ? globalThis.String(object.switchGroupPluggablePid)
        : "",
      switchGroupBreakout: isSet(object.switchGroupBreakout) ? globalThis.Boolean(object.switchGroupBreakout) : false,
      railGroupId: isSet(object.railGroupId) ? globalThis.String(object.railGroupId) : "",
      numDirectConnections: isSet(object.numDirectConnections) ? globalThis.Number(object.numDirectConnections) : 0,
      portGroupType: isSet(object.portGroupType) ? serverPortGroupTypeFromJSON(object.portGroupType) : 0,
      strategy: isSet(object.strategy) ? cablingStrategyFromJSON(object.strategy) : 0,
      ipmProbes: globalThis.Array.isArray(object?.ipmProbes)
        ? object.ipmProbes.map((e: any) => IpmSetting.fromJSON(e))
        : [],
      notes: isSet(object.notes) ? globalThis.String(object.notes) : "",
      portSetId: isSet(object.portSetId) ? globalThis.Number(object.portSetId) : 0,
      mtu: isSet(object.mtu) ? globalThis.Number(object.mtu) : 0,
      fec: isSet(object.fec) ? globalThis.String(object.fec) : "",
      torTrayIds: globalThis.Array.isArray(object?.torTrayIds)
        ? object.torTrayIds.map((e: any) => globalThis.Number(e))
        : [],
      serverTrayModelName: isSet(object.serverTrayModelName) ? globalThis.String(object.serverTrayModelName) : "",
    };
  },

  toJSON(message: ServerGroupConnectivityRule): unknown {
    const obj: any = {};
    if (message.ruleId !== "") {
      obj.ruleId = message.ruleId;
    }
    if (message.serverGroupId !== "") {
      obj.serverGroupId = message.serverGroupId;
    }
    if (message.serverGroupPluggablePid !== "") {
      obj.serverGroupPluggablePid = message.serverGroupPluggablePid;
    }
    if (message.cablePid !== "") {
      obj.cablePid = message.cablePid;
    }
    if (message.switchGroupId !== "") {
      obj.switchGroupId = message.switchGroupId;
    }
    if (message.switchGroupPluggablePid !== "") {
      obj.switchGroupPluggablePid = message.switchGroupPluggablePid;
    }
    if (message.switchGroupBreakout !== false) {
      obj.switchGroupBreakout = message.switchGroupBreakout;
    }
    if (message.railGroupId !== "") {
      obj.railGroupId = message.railGroupId;
    }
    if (message.numDirectConnections !== 0) {
      obj.numDirectConnections = Math.round(message.numDirectConnections);
    }
    if (message.portGroupType !== 0) {
      obj.portGroupType = serverPortGroupTypeToJSON(message.portGroupType);
    }
    if (message.strategy !== 0) {
      obj.strategy = cablingStrategyToJSON(message.strategy);
    }
    if (message.ipmProbes?.length) {
      obj.ipmProbes = message.ipmProbes.map((e) => IpmSetting.toJSON(e));
    }
    if (message.notes !== "") {
      obj.notes = message.notes;
    }
    if (message.portSetId !== 0) {
      obj.portSetId = Math.round(message.portSetId);
    }
    if (message.mtu !== 0) {
      obj.mtu = Math.round(message.mtu);
    }
    if (message.fec !== "") {
      obj.fec = message.fec;
    }
    if (message.torTrayIds?.length) {
      obj.torTrayIds = message.torTrayIds.map((e) => Math.round(e));
    }
    if (message.serverTrayModelName !== "") {
      obj.serverTrayModelName = message.serverTrayModelName;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ServerGroupConnectivityRule>, I>>(base?: I): ServerGroupConnectivityRule {
    return ServerGroupConnectivityRule.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ServerGroupConnectivityRule>, I>>(object: I): ServerGroupConnectivityRule {
    const message = createBaseServerGroupConnectivityRule();
    message.ruleId = object.ruleId ?? "";
    message.serverGroupId = object.serverGroupId ?? "";
    message.serverGroupPluggablePid = object.serverGroupPluggablePid ?? "";
    message.cablePid = object.cablePid ?? "";
    message.switchGroupId = object.switchGroupId ?? "";
    message.switchGroupPluggablePid = object.switchGroupPluggablePid ?? "";
    message.switchGroupBreakout = object.switchGroupBreakout ?? false;
    message.railGroupId = object.railGroupId ?? "";
    message.numDirectConnections = object.numDirectConnections ?? 0;
    message.portGroupType = object.portGroupType ?? 0;
    message.strategy = object.strategy ?? 0;
    message.ipmProbes = object.ipmProbes?.map((e) => IpmSetting.fromPartial(e)) || [];
    message.notes = object.notes ?? "";
    message.portSetId = object.portSetId ?? 0;
    message.mtu = object.mtu ?? 0;
    message.fec = object.fec ?? "";
    message.torTrayIds = object.torTrayIds?.map((e) => e) || [];
    message.serverTrayModelName = object.serverTrayModelName ?? "";
    return message;
  },
};

function createBaseNodePortConnectivityRule(): NodePortConnectivityRule {
  return {
    ruleId: "",
    node1Id: "",
    node1PortName: "",
    node1PortPluggablePid: "",
    cablePid: "",
    node2Id: "",
    node2PortName: "",
    node2PortPluggablePid: "",
    notes: "",
    mtu: 0,
    fec: "",
    node1TrayId: 0,
    node2TrayId: 0,
  };
}

export const NodePortConnectivityRule: MessageFns<NodePortConnectivityRule> = {
  encode(message: NodePortConnectivityRule, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.ruleId !== "") {
      writer.uint32(10).string(message.ruleId);
    }
    if (message.node1Id !== "") {
      writer.uint32(18).string(message.node1Id);
    }
    if (message.node1PortName !== "") {
      writer.uint32(26).string(message.node1PortName);
    }
    if (message.node1PortPluggablePid !== "") {
      writer.uint32(34).string(message.node1PortPluggablePid);
    }
    if (message.cablePid !== "") {
      writer.uint32(42).string(message.cablePid);
    }
    if (message.node2Id !== "") {
      writer.uint32(50).string(message.node2Id);
    }
    if (message.node2PortName !== "") {
      writer.uint32(58).string(message.node2PortName);
    }
    if (message.node2PortPluggablePid !== "") {
      writer.uint32(66).string(message.node2PortPluggablePid);
    }
    if (message.notes !== "") {
      writer.uint32(74).string(message.notes);
    }
    if (message.mtu !== 0) {
      writer.uint32(80).uint32(message.mtu);
    }
    if (message.fec !== "") {
      writer.uint32(90).string(message.fec);
    }
    if (message.node1TrayId !== 0) {
      writer.uint32(96).uint32(message.node1TrayId);
    }
    if (message.node2TrayId !== 0) {
      writer.uint32(104).uint32(message.node2TrayId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): NodePortConnectivityRule {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseNodePortConnectivityRule();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.ruleId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.node1Id = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.node1PortName = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.node1PortPluggablePid = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.cablePid = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.node2Id = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.node2PortName = reader.string();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.node2PortPluggablePid = reader.string();
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.notes = reader.string();
          continue;
        }
        case 10: {
          if (tag !== 80) {
            break;
          }

          message.mtu = reader.uint32();
          continue;
        }
        case 11: {
          if (tag !== 90) {
            break;
          }

          message.fec = reader.string();
          continue;
        }
        case 12: {
          if (tag !== 96) {
            break;
          }

          message.node1TrayId = reader.uint32();
          continue;
        }
        case 13: {
          if (tag !== 104) {
            break;
          }

          message.node2TrayId = reader.uint32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): NodePortConnectivityRule {
    return {
      ruleId: isSet(object.ruleId) ? globalThis.String(object.ruleId) : "",
      node1Id: isSet(object.node1Id) ? globalThis.String(object.node1Id) : "",
      node1PortName: isSet(object.node1PortName) ? globalThis.String(object.node1PortName) : "",
      node1PortPluggablePid: isSet(object.node1PortPluggablePid) ? globalThis.String(object.node1PortPluggablePid) : "",
      cablePid: isSet(object.cablePid) ? globalThis.String(object.cablePid) : "",
      node2Id: isSet(object.node2Id) ? globalThis.String(object.node2Id) : "",
      node2PortName: isSet(object.node2PortName) ? globalThis.String(object.node2PortName) : "",
      node2PortPluggablePid: isSet(object.node2PortPluggablePid) ? globalThis.String(object.node2PortPluggablePid) : "",
      notes: isSet(object.notes) ? globalThis.String(object.notes) : "",
      mtu: isSet(object.mtu) ? globalThis.Number(object.mtu) : 0,
      fec: isSet(object.fec) ? globalThis.String(object.fec) : "",
      node1TrayId: isSet(object.node1TrayId) ? globalThis.Number(object.node1TrayId) : 0,
      node2TrayId: isSet(object.node2TrayId) ? globalThis.Number(object.node2TrayId) : 0,
    };
  },

  toJSON(message: NodePortConnectivityRule): unknown {
    const obj: any = {};
    if (message.ruleId !== "") {
      obj.ruleId = message.ruleId;
    }
    if (message.node1Id !== "") {
      obj.node1Id = message.node1Id;
    }
    if (message.node1PortName !== "") {
      obj.node1PortName = message.node1PortName;
    }
    if (message.node1PortPluggablePid !== "") {
      obj.node1PortPluggablePid = message.node1PortPluggablePid;
    }
    if (message.cablePid !== "") {
      obj.cablePid = message.cablePid;
    }
    if (message.node2Id !== "") {
      obj.node2Id = message.node2Id;
    }
    if (message.node2PortName !== "") {
      obj.node2PortName = message.node2PortName;
    }
    if (message.node2PortPluggablePid !== "") {
      obj.node2PortPluggablePid = message.node2PortPluggablePid;
    }
    if (message.notes !== "") {
      obj.notes = message.notes;
    }
    if (message.mtu !== 0) {
      obj.mtu = Math.round(message.mtu);
    }
    if (message.fec !== "") {
      obj.fec = message.fec;
    }
    if (message.node1TrayId !== 0) {
      obj.node1TrayId = Math.round(message.node1TrayId);
    }
    if (message.node2TrayId !== 0) {
      obj.node2TrayId = Math.round(message.node2TrayId);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<NodePortConnectivityRule>, I>>(base?: I): NodePortConnectivityRule {
    return NodePortConnectivityRule.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<NodePortConnectivityRule>, I>>(object: I): NodePortConnectivityRule {
    const message = createBaseNodePortConnectivityRule();
    message.ruleId = object.ruleId ?? "";
    message.node1Id = object.node1Id ?? "";
    message.node1PortName = object.node1PortName ?? "";
    message.node1PortPluggablePid = object.node1PortPluggablePid ?? "";
    message.cablePid = object.cablePid ?? "";
    message.node2Id = object.node2Id ?? "";
    message.node2PortName = object.node2PortName ?? "";
    message.node2PortPluggablePid = object.node2PortPluggablePid ?? "";
    message.notes = object.notes ?? "";
    message.mtu = object.mtu ?? 0;
    message.fec = object.fec ?? "";
    message.node1TrayId = object.node1TrayId ?? 0;
    message.node2TrayId = object.node2TrayId ?? 0;
    return message;
  },
};

function createBaseNodePortOverrideRule(): NodePortOverrideRule {
  return { ruleId: "", nodeId: "", portName: "", pluggable: "", notes: "", trayId: 0 };
}

export const NodePortOverrideRule: MessageFns<NodePortOverrideRule> = {
  encode(message: NodePortOverrideRule, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.ruleId !== "") {
      writer.uint32(10).string(message.ruleId);
    }
    if (message.nodeId !== "") {
      writer.uint32(18).string(message.nodeId);
    }
    if (message.portName !== "") {
      writer.uint32(26).string(message.portName);
    }
    if (message.pluggable !== "") {
      writer.uint32(34).string(message.pluggable);
    }
    if (message.notes !== "") {
      writer.uint32(42).string(message.notes);
    }
    if (message.trayId !== 0) {
      writer.uint32(48).uint32(message.trayId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): NodePortOverrideRule {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseNodePortOverrideRule();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.ruleId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.nodeId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.portName = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.pluggable = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.notes = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.trayId = reader.uint32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): NodePortOverrideRule {
    return {
      ruleId: isSet(object.ruleId) ? globalThis.String(object.ruleId) : "",
      nodeId: isSet(object.nodeId) ? globalThis.String(object.nodeId) : "",
      portName: isSet(object.portName) ? globalThis.String(object.portName) : "",
      pluggable: isSet(object.pluggable) ? globalThis.String(object.pluggable) : "",
      notes: isSet(object.notes) ? globalThis.String(object.notes) : "",
      trayId: isSet(object.trayId) ? globalThis.Number(object.trayId) : 0,
    };
  },

  toJSON(message: NodePortOverrideRule): unknown {
    const obj: any = {};
    if (message.ruleId !== "") {
      obj.ruleId = message.ruleId;
    }
    if (message.nodeId !== "") {
      obj.nodeId = message.nodeId;
    }
    if (message.portName !== "") {
      obj.portName = message.portName;
    }
    if (message.pluggable !== "") {
      obj.pluggable = message.pluggable;
    }
    if (message.notes !== "") {
      obj.notes = message.notes;
    }
    if (message.trayId !== 0) {
      obj.trayId = Math.round(message.trayId);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<NodePortOverrideRule>, I>>(base?: I): NodePortOverrideRule {
    return NodePortOverrideRule.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<NodePortOverrideRule>, I>>(object: I): NodePortOverrideRule {
    const message = createBaseNodePortOverrideRule();
    message.ruleId = object.ruleId ?? "";
    message.nodeId = object.nodeId ?? "";
    message.portName = object.portName ?? "";
    message.pluggable = object.pluggable ?? "";
    message.notes = object.notes ?? "";
    message.trayId = object.trayId ?? 0;
    return message;
  },
};

function createBaseCablingEndpoint(): CablingEndpoint {
  return { nodeName: "", nodeId: "", portName: "", portId: "", groupName: "", groupId: "", trayId: 0, parentId: "" };
}

export const CablingEndpoint: MessageFns<CablingEndpoint> = {
  encode(message: CablingEndpoint, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.nodeName !== "") {
      writer.uint32(10).string(message.nodeName);
    }
    if (message.nodeId !== "") {
      writer.uint32(18).string(message.nodeId);
    }
    if (message.portName !== "") {
      writer.uint32(26).string(message.portName);
    }
    if (message.portId !== "") {
      writer.uint32(34).string(message.portId);
    }
    if (message.groupName !== "") {
      writer.uint32(42).string(message.groupName);
    }
    if (message.groupId !== "") {
      writer.uint32(50).string(message.groupId);
    }
    if (message.trayId !== 0) {
      writer.uint32(56).uint32(message.trayId);
    }
    if (message.parentId !== "") {
      writer.uint32(66).string(message.parentId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CablingEndpoint {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCablingEndpoint();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.nodeName = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.nodeId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.portName = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.portId = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.groupName = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.groupId = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.trayId = reader.uint32();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.parentId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CablingEndpoint {
    return {
      nodeName: isSet(object.nodeName) ? globalThis.String(object.nodeName) : "",
      nodeId: isSet(object.nodeId) ? globalThis.String(object.nodeId) : "",
      portName: isSet(object.portName) ? globalThis.String(object.portName) : "",
      portId: isSet(object.portId) ? globalThis.String(object.portId) : "",
      groupName: isSet(object.groupName) ? globalThis.String(object.groupName) : "",
      groupId: isSet(object.groupId) ? globalThis.String(object.groupId) : "",
      trayId: isSet(object.trayId) ? globalThis.Number(object.trayId) : 0,
      parentId: isSet(object.parentId) ? globalThis.String(object.parentId) : "",
    };
  },

  toJSON(message: CablingEndpoint): unknown {
    const obj: any = {};
    if (message.nodeName !== "") {
      obj.nodeName = message.nodeName;
    }
    if (message.nodeId !== "") {
      obj.nodeId = message.nodeId;
    }
    if (message.portName !== "") {
      obj.portName = message.portName;
    }
    if (message.portId !== "") {
      obj.portId = message.portId;
    }
    if (message.groupName !== "") {
      obj.groupName = message.groupName;
    }
    if (message.groupId !== "") {
      obj.groupId = message.groupId;
    }
    if (message.trayId !== 0) {
      obj.trayId = Math.round(message.trayId);
    }
    if (message.parentId !== "") {
      obj.parentId = message.parentId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CablingEndpoint>, I>>(base?: I): CablingEndpoint {
    return CablingEndpoint.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CablingEndpoint>, I>>(object: I): CablingEndpoint {
    const message = createBaseCablingEndpoint();
    message.nodeName = object.nodeName ?? "";
    message.nodeId = object.nodeId ?? "";
    message.portName = object.portName ?? "";
    message.portId = object.portId ?? "";
    message.groupName = object.groupName ?? "";
    message.groupId = object.groupId ?? "";
    message.trayId = object.trayId ?? 0;
    message.parentId = object.parentId ?? "";
    return message;
  },
};

function createBaseCablingConnection(): CablingConnection {
  return {
    local: undefined,
    remote: undefined,
    pluggable: "",
    remotePluggable: "",
    cablePid: "",
    remoteRailName: "",
    remoteRailId: "",
    remoteRailGroupName: "",
    remoteRailGroupId: "",
    connSourceType: 0,
    ruleId: "",
  };
}

export const CablingConnection: MessageFns<CablingConnection> = {
  encode(message: CablingConnection, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.local !== undefined) {
      CablingEndpoint.encode(message.local, writer.uint32(10).fork()).join();
    }
    if (message.remote !== undefined) {
      CablingEndpoint.encode(message.remote, writer.uint32(18).fork()).join();
    }
    if (message.pluggable !== "") {
      writer.uint32(26).string(message.pluggable);
    }
    if (message.remotePluggable !== "") {
      writer.uint32(34).string(message.remotePluggable);
    }
    if (message.cablePid !== "") {
      writer.uint32(42).string(message.cablePid);
    }
    if (message.remoteRailName !== "") {
      writer.uint32(50).string(message.remoteRailName);
    }
    if (message.remoteRailId !== "") {
      writer.uint32(58).string(message.remoteRailId);
    }
    if (message.remoteRailGroupName !== "") {
      writer.uint32(66).string(message.remoteRailGroupName);
    }
    if (message.remoteRailGroupId !== "") {
      writer.uint32(74).string(message.remoteRailGroupId);
    }
    if (message.connSourceType !== 0) {
      writer.uint32(80).int32(message.connSourceType);
    }
    if (message.ruleId !== "") {
      writer.uint32(90).string(message.ruleId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CablingConnection {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCablingConnection();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.local = CablingEndpoint.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.remote = CablingEndpoint.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.pluggable = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.remotePluggable = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.cablePid = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.remoteRailName = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.remoteRailId = reader.string();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.remoteRailGroupName = reader.string();
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.remoteRailGroupId = reader.string();
          continue;
        }
        case 10: {
          if (tag !== 80) {
            break;
          }

          message.connSourceType = reader.int32() as any;
          continue;
        }
        case 11: {
          if (tag !== 90) {
            break;
          }

          message.ruleId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CablingConnection {
    return {
      local: isSet(object.local) ? CablingEndpoint.fromJSON(object.local) : undefined,
      remote: isSet(object.remote) ? CablingEndpoint.fromJSON(object.remote) : undefined,
      pluggable: isSet(object.pluggable) ? globalThis.String(object.pluggable) : "",
      remotePluggable: isSet(object.remotePluggable) ? globalThis.String(object.remotePluggable) : "",
      cablePid: isSet(object.cablePid) ? globalThis.String(object.cablePid) : "",
      remoteRailName: isSet(object.remoteRailName) ? globalThis.String(object.remoteRailName) : "",
      remoteRailId: isSet(object.remoteRailId) ? globalThis.String(object.remoteRailId) : "",
      remoteRailGroupName: isSet(object.remoteRailGroupName) ? globalThis.String(object.remoteRailGroupName) : "",
      remoteRailGroupId: isSet(object.remoteRailGroupId) ? globalThis.String(object.remoteRailGroupId) : "",
      connSourceType: isSet(object.connSourceType) ? connSourceTypeFromJSON(object.connSourceType) : 0,
      ruleId: isSet(object.ruleId) ? globalThis.String(object.ruleId) : "",
    };
  },

  toJSON(message: CablingConnection): unknown {
    const obj: any = {};
    if (message.local !== undefined) {
      obj.local = CablingEndpoint.toJSON(message.local);
    }
    if (message.remote !== undefined) {
      obj.remote = CablingEndpoint.toJSON(message.remote);
    }
    if (message.pluggable !== "") {
      obj.pluggable = message.pluggable;
    }
    if (message.remotePluggable !== "") {
      obj.remotePluggable = message.remotePluggable;
    }
    if (message.cablePid !== "") {
      obj.cablePid = message.cablePid;
    }
    if (message.remoteRailName !== "") {
      obj.remoteRailName = message.remoteRailName;
    }
    if (message.remoteRailId !== "") {
      obj.remoteRailId = message.remoteRailId;
    }
    if (message.remoteRailGroupName !== "") {
      obj.remoteRailGroupName = message.remoteRailGroupName;
    }
    if (message.remoteRailGroupId !== "") {
      obj.remoteRailGroupId = message.remoteRailGroupId;
    }
    if (message.connSourceType !== 0) {
      obj.connSourceType = connSourceTypeToJSON(message.connSourceType);
    }
    if (message.ruleId !== "") {
      obj.ruleId = message.ruleId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CablingConnection>, I>>(base?: I): CablingConnection {
    return CablingConnection.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CablingConnection>, I>>(object: I): CablingConnection {
    const message = createBaseCablingConnection();
    message.local = (object.local !== undefined && object.local !== null)
      ? CablingEndpoint.fromPartial(object.local)
      : undefined;
    message.remote = (object.remote !== undefined && object.remote !== null)
      ? CablingEndpoint.fromPartial(object.remote)
      : undefined;
    message.pluggable = object.pluggable ?? "";
    message.remotePluggable = object.remotePluggable ?? "";
    message.cablePid = object.cablePid ?? "";
    message.remoteRailName = object.remoteRailName ?? "";
    message.remoteRailId = object.remoteRailId ?? "";
    message.remoteRailGroupName = object.remoteRailGroupName ?? "";
    message.remoteRailGroupId = object.remoteRailGroupId ?? "";
    message.connSourceType = object.connSourceType ?? 0;
    message.ruleId = object.ruleId ?? "";
    return message;
  },
};

function createBaseFabricDesign(): FabricDesign {
  return {
    fabricId: "",
    tiers: [],
    railGroups: [],
    switchGroupConnRules: [],
    serverGroupConnRules: [],
    nodePortConnRules: [],
    nodePortOverrideRules: [],
    isPartialSet: false,
    mgmtAuthConfigs: [],
  };
}

export const FabricDesign: MessageFns<FabricDesign> = {
  encode(message: FabricDesign, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.fabricId !== "") {
      writer.uint32(10).string(message.fabricId);
    }
    for (const v of message.tiers) {
      Tier.encode(v!, writer.uint32(18).fork()).join();
    }
    for (const v of message.railGroups) {
      RailGroup.encode(v!, writer.uint32(26).fork()).join();
    }
    for (const v of message.switchGroupConnRules) {
      SwitchGroupConnectivityRule.encode(v!, writer.uint32(34).fork()).join();
    }
    for (const v of message.serverGroupConnRules) {
      ServerGroupConnectivityRule.encode(v!, writer.uint32(42).fork()).join();
    }
    for (const v of message.nodePortConnRules) {
      NodePortConnectivityRule.encode(v!, writer.uint32(50).fork()).join();
    }
    for (const v of message.nodePortOverrideRules) {
      NodePortOverrideRule.encode(v!, writer.uint32(58).fork()).join();
    }
    if (message.isPartialSet !== false) {
      writer.uint32(64).bool(message.isPartialSet);
    }
    for (const v of message.mgmtAuthConfigs) {
      MgmtAuthConfig.encode(v!, writer.uint32(74).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): FabricDesign {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseFabricDesign();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.tiers.push(Tier.decode(reader, reader.uint32()));
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.railGroups.push(RailGroup.decode(reader, reader.uint32()));
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.switchGroupConnRules.push(SwitchGroupConnectivityRule.decode(reader, reader.uint32()));
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.serverGroupConnRules.push(ServerGroupConnectivityRule.decode(reader, reader.uint32()));
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.nodePortConnRules.push(NodePortConnectivityRule.decode(reader, reader.uint32()));
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.nodePortOverrideRules.push(NodePortOverrideRule.decode(reader, reader.uint32()));
          continue;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.isPartialSet = reader.bool();
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.mgmtAuthConfigs.push(MgmtAuthConfig.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): FabricDesign {
    return {
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      tiers: globalThis.Array.isArray(object?.tiers) ? object.tiers.map((e: any) => Tier.fromJSON(e)) : [],
      railGroups: globalThis.Array.isArray(object?.railGroups)
        ? object.railGroups.map((e: any) => RailGroup.fromJSON(e))
        : [],
      switchGroupConnRules: globalThis.Array.isArray(object?.switchGroupConnRules)
        ? object.switchGroupConnRules.map((e: any) => SwitchGroupConnectivityRule.fromJSON(e))
        : [],
      serverGroupConnRules: globalThis.Array.isArray(object?.serverGroupConnRules)
        ? object.serverGroupConnRules.map((e: any) => ServerGroupConnectivityRule.fromJSON(e))
        : [],
      nodePortConnRules: globalThis.Array.isArray(object?.nodePortConnRules)
        ? object.nodePortConnRules.map((e: any) => NodePortConnectivityRule.fromJSON(e))
        : [],
      nodePortOverrideRules: globalThis.Array.isArray(object?.nodePortOverrideRules)
        ? object.nodePortOverrideRules.map((e: any) => NodePortOverrideRule.fromJSON(e))
        : [],
      isPartialSet: isSet(object.isPartialSet) ? globalThis.Boolean(object.isPartialSet) : false,
      mgmtAuthConfigs: globalThis.Array.isArray(object?.mgmtAuthConfigs)
        ? object.mgmtAuthConfigs.map((e: any) => MgmtAuthConfig.fromJSON(e))
        : [],
    };
  },

  toJSON(message: FabricDesign): unknown {
    const obj: any = {};
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.tiers?.length) {
      obj.tiers = message.tiers.map((e) => Tier.toJSON(e));
    }
    if (message.railGroups?.length) {
      obj.railGroups = message.railGroups.map((e) => RailGroup.toJSON(e));
    }
    if (message.switchGroupConnRules?.length) {
      obj.switchGroupConnRules = message.switchGroupConnRules.map((e) => SwitchGroupConnectivityRule.toJSON(e));
    }
    if (message.serverGroupConnRules?.length) {
      obj.serverGroupConnRules = message.serverGroupConnRules.map((e) => ServerGroupConnectivityRule.toJSON(e));
    }
    if (message.nodePortConnRules?.length) {
      obj.nodePortConnRules = message.nodePortConnRules.map((e) => NodePortConnectivityRule.toJSON(e));
    }
    if (message.nodePortOverrideRules?.length) {
      obj.nodePortOverrideRules = message.nodePortOverrideRules.map((e) => NodePortOverrideRule.toJSON(e));
    }
    if (message.isPartialSet !== false) {
      obj.isPartialSet = message.isPartialSet;
    }
    if (message.mgmtAuthConfigs?.length) {
      obj.mgmtAuthConfigs = message.mgmtAuthConfigs.map((e) => MgmtAuthConfig.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<FabricDesign>, I>>(base?: I): FabricDesign {
    return FabricDesign.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<FabricDesign>, I>>(object: I): FabricDesign {
    const message = createBaseFabricDesign();
    message.fabricId = object.fabricId ?? "";
    message.tiers = object.tiers?.map((e) => Tier.fromPartial(e)) || [];
    message.railGroups = object.railGroups?.map((e) => RailGroup.fromPartial(e)) || [];
    message.switchGroupConnRules =
      object.switchGroupConnRules?.map((e) => SwitchGroupConnectivityRule.fromPartial(e)) || [];
    message.serverGroupConnRules =
      object.serverGroupConnRules?.map((e) => ServerGroupConnectivityRule.fromPartial(e)) || [];
    message.nodePortConnRules = object.nodePortConnRules?.map((e) => NodePortConnectivityRule.fromPartial(e)) || [];
    message.nodePortOverrideRules = object.nodePortOverrideRules?.map((e) => NodePortOverrideRule.fromPartial(e)) || [];
    message.isPartialSet = object.isPartialSet ?? false;
    message.mgmtAuthConfigs = object.mgmtAuthConfigs?.map((e) => MgmtAuthConfig.fromPartial(e)) || [];
    return message;
  },
};

function createBaseMgmtCredential(): MgmtCredential {
  return { name: "", credentialId: "", username: "", password: "" };
}

export const MgmtCredential: MessageFns<MgmtCredential> = {
  encode(message: MgmtCredential, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.name !== "") {
      writer.uint32(10).string(message.name);
    }
    if (message.credentialId !== "") {
      writer.uint32(18).string(message.credentialId);
    }
    if (message.username !== "") {
      writer.uint32(26).string(message.username);
    }
    if (message.password !== "") {
      writer.uint32(34).string(message.password);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): MgmtCredential {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMgmtCredential();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.credentialId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.username = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.password = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): MgmtCredential {
    return {
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      credentialId: isSet(object.credentialId) ? globalThis.String(object.credentialId) : "",
      username: isSet(object.username) ? globalThis.String(object.username) : "",
      password: isSet(object.password) ? globalThis.String(object.password) : "",
    };
  },

  toJSON(message: MgmtCredential): unknown {
    const obj: any = {};
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.credentialId !== "") {
      obj.credentialId = message.credentialId;
    }
    if (message.username !== "") {
      obj.username = message.username;
    }
    if (message.password !== "") {
      obj.password = message.password;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<MgmtCredential>, I>>(base?: I): MgmtCredential {
    return MgmtCredential.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<MgmtCredential>, I>>(object: I): MgmtCredential {
    const message = createBaseMgmtCredential();
    message.name = object.name ?? "";
    message.credentialId = object.credentialId ?? "";
    message.username = object.username ?? "";
    message.password = object.password ?? "";
    return message;
  },
};

function createBaseMgmtNodeBinding(): MgmtNodeBinding {
  return { nodeId: "", nodeName: "", defaultCredential: undefined, slotBindings: [] };
}

export const MgmtNodeBinding: MessageFns<MgmtNodeBinding> = {
  encode(message: MgmtNodeBinding, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.nodeId !== "") {
      writer.uint32(10).string(message.nodeId);
    }
    if (message.nodeName !== "") {
      writer.uint32(18).string(message.nodeName);
    }
    if (message.defaultCredential !== undefined) {
      MgmtCredential.encode(message.defaultCredential, writer.uint32(26).fork()).join();
    }
    for (const v of message.slotBindings) {
      MgmtSlotBinding.encode(v!, writer.uint32(34).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): MgmtNodeBinding {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMgmtNodeBinding();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.nodeId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.nodeName = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.defaultCredential = MgmtCredential.decode(reader, reader.uint32());
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.slotBindings.push(MgmtSlotBinding.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): MgmtNodeBinding {
    return {
      nodeId: isSet(object.nodeId) ? globalThis.String(object.nodeId) : "",
      nodeName: isSet(object.nodeName) ? globalThis.String(object.nodeName) : "",
      defaultCredential: isSet(object.defaultCredential)
        ? MgmtCredential.fromJSON(object.defaultCredential)
        : undefined,
      slotBindings: globalThis.Array.isArray(object?.slotBindings)
        ? object.slotBindings.map((e: any) => MgmtSlotBinding.fromJSON(e))
        : [],
    };
  },

  toJSON(message: MgmtNodeBinding): unknown {
    const obj: any = {};
    if (message.nodeId !== "") {
      obj.nodeId = message.nodeId;
    }
    if (message.nodeName !== "") {
      obj.nodeName = message.nodeName;
    }
    if (message.defaultCredential !== undefined) {
      obj.defaultCredential = MgmtCredential.toJSON(message.defaultCredential);
    }
    if (message.slotBindings?.length) {
      obj.slotBindings = message.slotBindings.map((e) => MgmtSlotBinding.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<MgmtNodeBinding>, I>>(base?: I): MgmtNodeBinding {
    return MgmtNodeBinding.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<MgmtNodeBinding>, I>>(object: I): MgmtNodeBinding {
    const message = createBaseMgmtNodeBinding();
    message.nodeId = object.nodeId ?? "";
    message.nodeName = object.nodeName ?? "";
    message.defaultCredential = (object.defaultCredential !== undefined && object.defaultCredential !== null)
      ? MgmtCredential.fromPartial(object.defaultCredential)
      : undefined;
    message.slotBindings = object.slotBindings?.map((e) => MgmtSlotBinding.fromPartial(e)) || [];
    return message;
  },
};

function createBaseMgmtSlotBinding(): MgmtSlotBinding {
  return { slotNumber: 0, ipv4Address: "", ipv6Address: "", credential: undefined, credentialBinding: 0 };
}

export const MgmtSlotBinding: MessageFns<MgmtSlotBinding> = {
  encode(message: MgmtSlotBinding, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.slotNumber !== 0) {
      writer.uint32(8).uint32(message.slotNumber);
    }
    if (message.ipv4Address !== "") {
      writer.uint32(18).string(message.ipv4Address);
    }
    if (message.ipv6Address !== "") {
      writer.uint32(26).string(message.ipv6Address);
    }
    if (message.credential !== undefined) {
      MgmtCredential.encode(message.credential, writer.uint32(34).fork()).join();
    }
    if (message.credentialBinding !== 0) {
      writer.uint32(40).int32(message.credentialBinding);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): MgmtSlotBinding {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMgmtSlotBinding();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.slotNumber = reader.uint32();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.ipv4Address = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.ipv6Address = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.credential = MgmtCredential.decode(reader, reader.uint32());
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.credentialBinding = reader.int32() as any;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): MgmtSlotBinding {
    return {
      slotNumber: isSet(object.slotNumber) ? globalThis.Number(object.slotNumber) : 0,
      ipv4Address: isSet(object.ipv4Address) ? globalThis.String(object.ipv4Address) : "",
      ipv6Address: isSet(object.ipv6Address) ? globalThis.String(object.ipv6Address) : "",
      credential: isSet(object.credential) ? MgmtCredential.fromJSON(object.credential) : undefined,
      credentialBinding: isSet(object.credentialBinding) ? mgmtCredentialBindingFromJSON(object.credentialBinding) : 0,
    };
  },

  toJSON(message: MgmtSlotBinding): unknown {
    const obj: any = {};
    if (message.slotNumber !== 0) {
      obj.slotNumber = Math.round(message.slotNumber);
    }
    if (message.ipv4Address !== "") {
      obj.ipv4Address = message.ipv4Address;
    }
    if (message.ipv6Address !== "") {
      obj.ipv6Address = message.ipv6Address;
    }
    if (message.credential !== undefined) {
      obj.credential = MgmtCredential.toJSON(message.credential);
    }
    if (message.credentialBinding !== 0) {
      obj.credentialBinding = mgmtCredentialBindingToJSON(message.credentialBinding);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<MgmtSlotBinding>, I>>(base?: I): MgmtSlotBinding {
    return MgmtSlotBinding.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<MgmtSlotBinding>, I>>(object: I): MgmtSlotBinding {
    const message = createBaseMgmtSlotBinding();
    message.slotNumber = object.slotNumber ?? 0;
    message.ipv4Address = object.ipv4Address ?? "";
    message.ipv6Address = object.ipv6Address ?? "";
    message.credential = (object.credential !== undefined && object.credential !== null)
      ? MgmtCredential.fromPartial(object.credential)
      : undefined;
    message.credentialBinding = object.credentialBinding ?? 0;
    return message;
  },
};

function createBaseMgmtAuthConfig(): MgmtAuthConfig {
  return {
    serverGroupId: "",
    autoDiscovery: false,
    defaultCredential: undefined,
    nodeBindings: [],
    csvData: new Uint8Array(0),
    portGroupType: 0,
    connectivityRuleId: "",
  };
}

export const MgmtAuthConfig: MessageFns<MgmtAuthConfig> = {
  encode(message: MgmtAuthConfig, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.serverGroupId !== "") {
      writer.uint32(10).string(message.serverGroupId);
    }
    if (message.autoDiscovery !== false) {
      writer.uint32(16).bool(message.autoDiscovery);
    }
    if (message.defaultCredential !== undefined) {
      MgmtCredential.encode(message.defaultCredential, writer.uint32(26).fork()).join();
    }
    for (const v of message.nodeBindings) {
      MgmtNodeBinding.encode(v!, writer.uint32(34).fork()).join();
    }
    if (message.csvData.length !== 0) {
      writer.uint32(42).bytes(message.csvData);
    }
    if (message.portGroupType !== 0) {
      writer.uint32(48).int32(message.portGroupType);
    }
    if (message.connectivityRuleId !== "") {
      writer.uint32(58).string(message.connectivityRuleId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): MgmtAuthConfig {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMgmtAuthConfig();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.serverGroupId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.autoDiscovery = reader.bool();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.defaultCredential = MgmtCredential.decode(reader, reader.uint32());
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.nodeBindings.push(MgmtNodeBinding.decode(reader, reader.uint32()));
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.csvData = reader.bytes();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.portGroupType = reader.int32() as any;
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.connectivityRuleId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): MgmtAuthConfig {
    return {
      serverGroupId: isSet(object.serverGroupId) ? globalThis.String(object.serverGroupId) : "",
      autoDiscovery: isSet(object.autoDiscovery) ? globalThis.Boolean(object.autoDiscovery) : false,
      defaultCredential: isSet(object.defaultCredential)
        ? MgmtCredential.fromJSON(object.defaultCredential)
        : undefined,
      nodeBindings: globalThis.Array.isArray(object?.nodeBindings)
        ? object.nodeBindings.map((e: any) => MgmtNodeBinding.fromJSON(e))
        : [],
      csvData: isSet(object.csvData) ? bytesFromBase64(object.csvData) : new Uint8Array(0),
      portGroupType: isSet(object.portGroupType) ? serverPortGroupTypeFromJSON(object.portGroupType) : 0,
      connectivityRuleId: isSet(object.connectivityRuleId) ? globalThis.String(object.connectivityRuleId) : "",
    };
  },

  toJSON(message: MgmtAuthConfig): unknown {
    const obj: any = {};
    if (message.serverGroupId !== "") {
      obj.serverGroupId = message.serverGroupId;
    }
    if (message.autoDiscovery !== false) {
      obj.autoDiscovery = message.autoDiscovery;
    }
    if (message.defaultCredential !== undefined) {
      obj.defaultCredential = MgmtCredential.toJSON(message.defaultCredential);
    }
    if (message.nodeBindings?.length) {
      obj.nodeBindings = message.nodeBindings.map((e) => MgmtNodeBinding.toJSON(e));
    }
    if (message.csvData.length !== 0) {
      obj.csvData = base64FromBytes(message.csvData);
    }
    if (message.portGroupType !== 0) {
      obj.portGroupType = serverPortGroupTypeToJSON(message.portGroupType);
    }
    if (message.connectivityRuleId !== "") {
      obj.connectivityRuleId = message.connectivityRuleId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<MgmtAuthConfig>, I>>(base?: I): MgmtAuthConfig {
    return MgmtAuthConfig.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<MgmtAuthConfig>, I>>(object: I): MgmtAuthConfig {
    const message = createBaseMgmtAuthConfig();
    message.serverGroupId = object.serverGroupId ?? "";
    message.autoDiscovery = object.autoDiscovery ?? false;
    message.defaultCredential = (object.defaultCredential !== undefined && object.defaultCredential !== null)
      ? MgmtCredential.fromPartial(object.defaultCredential)
      : undefined;
    message.nodeBindings = object.nodeBindings?.map((e) => MgmtNodeBinding.fromPartial(e)) || [];
    message.csvData = object.csvData ?? new Uint8Array(0);
    message.portGroupType = object.portGroupType ?? 0;
    message.connectivityRuleId = object.connectivityRuleId ?? "";
    return message;
  },
};

function createBaseFabricBaseCloudConfig(): FabricBaseCloudConfig {
  return {
    fabricId: "",
    location: "",
    switchGroup: [],
    serverGroup: [],
    migrationStatus: "",
    fabricSoftwareConfig: undefined,
  };
}

export const FabricBaseCloudConfig: MessageFns<FabricBaseCloudConfig> = {
  encode(message: FabricBaseCloudConfig, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.fabricId !== "") {
      writer.uint32(10).string(message.fabricId);
    }
    if (message.location !== "") {
      writer.uint32(18).string(message.location);
    }
    for (const v of message.switchGroup) {
      GroupBaseCloudConfig.encode(v!, writer.uint32(26).fork()).join();
    }
    for (const v of message.serverGroup) {
      GroupBaseCloudConfig.encode(v!, writer.uint32(34).fork()).join();
    }
    if (message.migrationStatus !== "") {
      writer.uint32(42).string(message.migrationStatus);
    }
    if (message.fabricSoftwareConfig !== undefined) {
      FabricSoftwareConfig.encode(message.fabricSoftwareConfig, writer.uint32(50).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): FabricBaseCloudConfig {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseFabricBaseCloudConfig();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.location = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.switchGroup.push(GroupBaseCloudConfig.decode(reader, reader.uint32()));
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.serverGroup.push(GroupBaseCloudConfig.decode(reader, reader.uint32()));
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.migrationStatus = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.fabricSoftwareConfig = FabricSoftwareConfig.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): FabricBaseCloudConfig {
    return {
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      location: isSet(object.location) ? globalThis.String(object.location) : "",
      switchGroup: globalThis.Array.isArray(object?.switchGroup)
        ? object.switchGroup.map((e: any) => GroupBaseCloudConfig.fromJSON(e))
        : [],
      serverGroup: globalThis.Array.isArray(object?.serverGroup)
        ? object.serverGroup.map((e: any) => GroupBaseCloudConfig.fromJSON(e))
        : [],
      migrationStatus: isSet(object.migrationStatus) ? globalThis.String(object.migrationStatus) : "",
      fabricSoftwareConfig: isSet(object.fabricSoftwareConfig)
        ? FabricSoftwareConfig.fromJSON(object.fabricSoftwareConfig)
        : undefined,
    };
  },

  toJSON(message: FabricBaseCloudConfig): unknown {
    const obj: any = {};
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.location !== "") {
      obj.location = message.location;
    }
    if (message.switchGroup?.length) {
      obj.switchGroup = message.switchGroup.map((e) => GroupBaseCloudConfig.toJSON(e));
    }
    if (message.serverGroup?.length) {
      obj.serverGroup = message.serverGroup.map((e) => GroupBaseCloudConfig.toJSON(e));
    }
    if (message.migrationStatus !== "") {
      obj.migrationStatus = message.migrationStatus;
    }
    if (message.fabricSoftwareConfig !== undefined) {
      obj.fabricSoftwareConfig = FabricSoftwareConfig.toJSON(message.fabricSoftwareConfig);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<FabricBaseCloudConfig>, I>>(base?: I): FabricBaseCloudConfig {
    return FabricBaseCloudConfig.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<FabricBaseCloudConfig>, I>>(object: I): FabricBaseCloudConfig {
    const message = createBaseFabricBaseCloudConfig();
    message.fabricId = object.fabricId ?? "";
    message.location = object.location ?? "";
    message.switchGroup = object.switchGroup?.map((e) => GroupBaseCloudConfig.fromPartial(e)) || [];
    message.serverGroup = object.serverGroup?.map((e) => GroupBaseCloudConfig.fromPartial(e)) || [];
    message.migrationStatus = object.migrationStatus ?? "";
    message.fabricSoftwareConfig = (object.fabricSoftwareConfig !== undefined && object.fabricSoftwareConfig !== null)
      ? FabricSoftwareConfig.fromPartial(object.fabricSoftwareConfig)
      : undefined;
    return message;
  },
};

function createBaseGroupBaseCloudConfig(): GroupBaseCloudConfig {
  return { baseData: undefined, overallGroupPosition: 0, activeGpuSlots: [], activeGpuBitmap: 0 };
}

export const GroupBaseCloudConfig: MessageFns<GroupBaseCloudConfig> = {
  encode(message: GroupBaseCloudConfig, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.baseData !== undefined) {
      DesignObjectBaseData.encode(message.baseData, writer.uint32(10).fork()).join();
    }
    if (message.overallGroupPosition !== 0) {
      writer.uint32(16).uint32(message.overallGroupPosition);
    }
    writer.uint32(26).fork();
    for (const v of message.activeGpuSlots) {
      writer.uint32(v);
    }
    writer.join();
    if (message.activeGpuBitmap !== 0) {
      writer.uint32(32).uint32(message.activeGpuBitmap);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GroupBaseCloudConfig {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGroupBaseCloudConfig();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.baseData = DesignObjectBaseData.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.overallGroupPosition = reader.uint32();
          continue;
        }
        case 3: {
          if (tag === 24) {
            message.activeGpuSlots.push(reader.uint32());

            continue;
          }

          if (tag === 26) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.activeGpuSlots.push(reader.uint32());
            }

            continue;
          }

          break;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.activeGpuBitmap = reader.uint32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GroupBaseCloudConfig {
    return {
      baseData: isSet(object.baseData) ? DesignObjectBaseData.fromJSON(object.baseData) : undefined,
      overallGroupPosition: isSet(object.overallGroupPosition) ? globalThis.Number(object.overallGroupPosition) : 0,
      activeGpuSlots: globalThis.Array.isArray(object?.activeGpuSlots)
        ? object.activeGpuSlots.map((e: any) => globalThis.Number(e))
        : [],
      activeGpuBitmap: isSet(object.activeGpuBitmap) ? globalThis.Number(object.activeGpuBitmap) : 0,
    };
  },

  toJSON(message: GroupBaseCloudConfig): unknown {
    const obj: any = {};
    if (message.baseData !== undefined) {
      obj.baseData = DesignObjectBaseData.toJSON(message.baseData);
    }
    if (message.overallGroupPosition !== 0) {
      obj.overallGroupPosition = Math.round(message.overallGroupPosition);
    }
    if (message.activeGpuSlots?.length) {
      obj.activeGpuSlots = message.activeGpuSlots.map((e) => Math.round(e));
    }
    if (message.activeGpuBitmap !== 0) {
      obj.activeGpuBitmap = Math.round(message.activeGpuBitmap);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GroupBaseCloudConfig>, I>>(base?: I): GroupBaseCloudConfig {
    return GroupBaseCloudConfig.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GroupBaseCloudConfig>, I>>(object: I): GroupBaseCloudConfig {
    const message = createBaseGroupBaseCloudConfig();
    message.baseData = (object.baseData !== undefined && object.baseData !== null)
      ? DesignObjectBaseData.fromPartial(object.baseData)
      : undefined;
    message.overallGroupPosition = object.overallGroupPosition ?? 0;
    message.activeGpuSlots = object.activeGpuSlots?.map((e) => e) || [];
    message.activeGpuBitmap = object.activeGpuBitmap ?? 0;
    return message;
  },
};

function bytesFromBase64(b64: string): Uint8Array {
  if ((globalThis as any).Buffer) {
    return Uint8Array.from(globalThis.Buffer.from(b64, "base64"));
  } else {
    const bin = globalThis.atob(b64);
    const arr = new Uint8Array(bin.length);
    for (let i = 0; i < bin.length; ++i) {
      arr[i] = bin.charCodeAt(i);
    }
    return arr;
  }
}

function base64FromBytes(arr: Uint8Array): string {
  if ((globalThis as any).Buffer) {
    return globalThis.Buffer.from(arr).toString("base64");
  } else {
    const bin: string[] = [];
    arr.forEach((byte) => {
      bin.push(globalThis.String.fromCharCode(byte));
    });
    return globalThis.btoa(bin.join(""));
  }
}

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
